<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary" @click="backParent">Sales</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Sales</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="sales.id === null">New</span>
                  <span v-else>{{ sales.sale_no }}</span>
                </li>
              </ol>
              <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="printsales" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Action</button>
              <div class="dropdown-menu" aria-labelledby="printsales">
                <a class="dropdown-item" href="javascript:void(0)" @click="print('invoice')">Print Invoice</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="print('bstk')">Print BSTK</a>
                <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalSalePrint" data-backdrop="static" data-keyboard="false" @click="printPreview">Print Preview</a>
                <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalRequestEdit" data-backdrop="static" data-keyboard="false">Request Edit</a>
                <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalRequestVoid" data-backdrop="static" data-keyboard="false">Request Delete</a>
                <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalRequestApprove" data-backdrop="static" data-keyboard="false">Request Approve</a>
                <a class="dropdown-item" href="javascript:void(0)" @click="setJournalAll">Set Journal</a>
                <!-- <a class="dropdown-item" href="javascript:void(0)" @click="setJournalSingle">Journal Invoice</a> -->
                <!-- <a class="dropdown-item" href="javascript:void(0)" @click="setJournalStockSingle">Journal Stock Out</a> -->
                <!-- <a href="javascript:void(0)" class="dropdown-item" @click="syncOrderAll('reply')">Sync Order ALl</a> -->
                <!-- <a href="javascript:void(0)" class="dropdown-item" @click="syncOrder2('reply')">Sync Order New</a> -->
                <a href="javascript:void(0)" class="dropdown-item" @click="setCOGSAll('reply')">Sync COGS</a>
                <a href="javascript:void(0)" class="dropdown-item" @click="validateDetailProduct">Validate</a>
                <a href="javascript:void(0)" class="dropdown-item" @click="getCustomerOutstanding">Customer Outstanding</a>
                <a href="javascript:void(0)" class="dropdown-item" @click="approvePermission" v-if="authUser.permissions.sales_approve_permission">Approve with Permission</a>
                <a href="javascript:void(0)" class="dropdown-item" @click="resetPrintCounter" v-if="authUser.permissions.sales_approve_permission">Reset Print Counter</a>
                <a href="javascript:void(0)" class="dropdown-item" @click="removeSales">Delete</a>
                <a href="javascript:void(0)" class="dropdown-item" @click="unlock">Unlock</a>
              </div>
              <!-- <button type="button" @click="createBastk" class="btn btn-sm btn-info pull-left" v-show="sales.sale_no !== null"><i class="fa fa-barcode"></i>BASTK</button> -->
              <!-- <button type="button" class="btn btn-sm btn-primary pull-right" data-toggle="modal" data-target="#modalProjectSale" data-backdrop="static" data-keyboard="false" v-if="sales.sale_no !== null">Create Project</button> -->
              <button type="button" @click="updateSales('reply')" class="btn btn-sm btn-soft-primary pull-left" v-show="sales.sale_no !== null && sales.lock === false"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
              <button type="button" @click="createSales" class="btn btn-sm btn-soft-primary pull-left" v-show="sales.sale_no == null"><i class="fa fa-check" aria-hidden="true"></i> Create</button>
              <button type="button" @click="approveAll" class="btn btn-sm btn-soft-primary pull-left" v-show="sales.sale_no !== null && sales.lock === false"><i class="fa fa-check" aria-hidden="true"></i> Approve</button>
              <!-- <button type="button" @click="validateDetailProduct" class="btn btn-sm btn-soft-primary pull-left"><i class="fa fa-check" aria-hidden="true"></i> Validate</button> -->
              <!-- <button type="button" @click="salesPayment" class="btn btn-sm btn-success pull-right" v-show="sales.sale_no !== null"><i class="fa fa-money"></i> Payment</button> -->
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div :class="card1">
          <div class="card card-list">
            <div class="card-header">
              <h5 v-if="sales.sale_no === null">New</h5>
              <h5 v-else>
                {{ sales.sale_no }}
                <span class="badge badge-warning" v-if="sales.status === 'outstanding'">{{ sales.status }}</span>
                <span class="badge badge-primary" v-else>{{ sales.status }}</span>
              </h5>
            </div>
            <div class="card-body">
              <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
                <ul v-for="(a, index) in alert" :key="index">
                  <li v-html="a"></li>
                </ul>
              </div>
              <div class="row">
                  <div class="col-md-4">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="customerOutstandingDueTotal > 0">
                      <span><strong><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Customer</strong> masih punya piutang overdue({{ settingDueDatePlafond }}): <strong>{{ customerOutstandingDueTotal | currency }}</strong></span>
                    </div>
                    <!-- parseFloat(this.customerOutstandingTotal) >= parseFloat(this.customerPlafondAmount) -->
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="customerOutstandingTotal >= customerPlafondAmount && customerPlafondAmount !== 0">
                      <span><strong><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Customer</strong> Piutang: ({{ customerOutstandingTotal | currency}}) lebih dari plafond piutang <strong>{{ customerPlafondAmount | currency }}</strong></span>
                    </div>
                    <dl class="row dl-custom font-12">
                      <dt class="col-md-4">Customer</dt>
                      <dd class="col-md-8">
                        <button type="button" data-toggle="modal" data-target="#modalCustomerForm" data-backdrop="static" data-keyboard="false"  class="btn btn-sm btn-hard-primary mr-1" :disabled="sales.lock">+ New</button>
                        <button type="button" data-toggle="modal" data-target="#modalCustomerList" data-backdrop="static" data-keyboard="false"  class="btn btn-sm btn-hard-primary" @click="getCustomerList" :disabled="sales.lock">List</button>
                        <button type="button" class="btn btn-sm btn-hard-primary ml-1" @click="getCustomerOrder" :disabled="sales.lock">Get Order</button>
                      </dd>
                      <dt class="col-md-4">Customer No</dt>
                      <dd class="col-md-8">{{ sales.customer_no }}</dd>
                      <dt class="col-md-4">Name</dt>
                      <dd class="col-md-8">{{ sales.customer.name }}</dd>
                      <dt class="col-md-4">Phone</dt>
                      <dd class="col-md-8">{{ sales.customer.phone }}</dd>
                      <dt class="col-md-4">Address</dt>
                      <dd class="col-md-8">{{ sales.customer.address }}</dd>
                      <dt class="col-md-4">Rating</dt>
                      <dd class="col-md-8">
                        <span class="badge badge-success" v-if="sales.customer.rating_id === 'good'">{{ sales.customer.rating }}</span>
                        <span class="badge badge-warning" v-else-if="sales.customer.rating_id === 'middle-low'">{{ sales.customer.rating }}</span>
                        <span class="badge badge-warning" v-else-if="sales.customer.rating_id === 'vip'">{{ sales.customer.rating }}</span>
                        <span class="badge badge-warning" v-else-if="sales.customer.rating_id === 'evaluate'">{{ sales.customer.rating }}</span>
                        <span class="badge badge-danger" v-else>{{ sales.customer.rating }}</span>
                      </dd>
                      <dt class="col-md-4">Plafond</dt>
                      <dd class="col-md-8">{{ sales.customer.plafond_amount | currency }}</dd>

                      <dt class="col-md-4">Oustanding</dt>
                      <dd class="col-md-8">{{ customerOutstandingTotal | currency }} [{{ customerOutstandingTotalSales }}] [{{ customerOutstandingTotalSalePaid }}]</dd>

                      <dt class="col-md-4">Piutang Overdue ({{settingDueDatePlafond }}):</dt>
                      <dd class="col-md-8">{{ customerOutstandingDueTotal | currency }}</dd>
                    </dl>
                    <dl class="row dl-custom font-12">
                      <dt class="col-md-4">Tgl.</dt>
                      <dd class="col-md-8"><!-- <span v-if="sales.lock">{{ sales.sale_date | dateFormat('DD/MM/YYYY') }}</span> -->
                        <span v-if="sales.id !== null">{{ sales.sale_date | dateFormat('DD/MM/YYYY') }}</span>
                        <span v-else>
                          <datetime v-model="sales.sale_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local" v-if="authUser.permissions.sale_backdate"></datetime>
                          <datetime v-model="sales.sale_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local" @input="checkDate" v-else :disabled="sales.lock"></datetime>
                        </span>
                      </dd>

                      <dt class="col-md-4">Jatuh Tempo</dt>
                      <dd class="col-md-8">
                        <select v-model="sales.term_due_id" class="form-control form-control-lite" :disabled="sales.lock">
                          <option v-for="t in termDueList" :key="t.id" :value="t.id">{{ t.name }}</option>
                          <option value=""><i>Custom</i></option>
                        </select>
                      </dd>
                      <dt class="col-md-4"></dt>
                      <dd class="col-md-8">
                        <span v-if="sales.lock">{{ sales.sale_due_date | dateFormat('DD/MM/YYYY') }}</span>
                      </dd>
                    </dl>
                    <!-- <div>
                      <pre>isPlafondOke: {{ isPlafondOke }}</pre>
                      <pre>customerOutstandingDueTotal: {{ customerOutstandingDueTotal}}</pre>
                      <pre>customerOutstandingTotal: {{ customerOutstandingTotal }}</pre>
                      <pre>customerPlafondAmount: {{ customerPlafondAmount }}</pre>
                      <pre>isEnablePlafond: {{ isEnablePlafond }}</pre>
                      <pre>isEnablePlafondDueDate: {{ isEnablePlafondDueDate }}</pre>
                    </div> -->
                  </div>
                  <div class="col-md-4">
                    <dl class="row dl-custom">
                      <dt class="col-md-4">Type</dt>
                      <dd class="col-md-8">
                        <select class="form-control form-control-lite" v-model="sales.type_id" :disabled="sales.lock" @change="setTypeSales">
                          <option v-for="t in salesTypeList" :key="t.id" :value="t.id">{{ t.name }}</option>
                        </select>
                      </dd>
                      <dt class="col-md-4">Salesman</dt>
                      <dd class="col-md-8">
                        <v-select :options="getUserSalesman" :reduce="salesman => salesman.meta.code" label="salesman" v-model="sales.salesman_id" class="vsc-custom" :disabled="sales.lock"/>
                      </dd>
                      <dt class="col-md-4">Sales Group</dt>
                      <dd class="col-md-8">
                        <v-select :options="getUserSalesman" :reduce="salesman => salesman.meta.code" label="salesman" v-model="sales.supervisor_id" class="vsc-custom" :disabled="sales.lock"/>
                      </dd>
                      <dt class="col-md-4">Company</dt>
                      <dd class="col-md-8">
                        <select v-model="sales.company_no" class="form-control form-control-lite" @change="checkTax" :disabled="sales.lock || sales.sale_no !== null">
                          <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                        </select>
                      </dd>
                      <dt class="col-md-4">Tax</dt>
                      <dd class="col-md-8">
                        <select v-model="sales.tax_id" class="form-control form-control-lite" @change="setTax" :disabled="sales.lock">
                          <option v-for="t in taxList" :key="t.id" :value="t.id">Tax: {{ t.name }}</option>
                        </select>
                      </dd>
                      <dt class="col-md-4">Driver</dt>
                      <dd class="col-md-8">
                        <v-select :options="getEmployeeDriver" :reduce="salesman => salesman.meta.code" label="salesman" v-model="sales.deliveries[0].employee_no" class="vsc-custom" :disabled="sales.lock"/>
                      </dd>
                      <dt class="col-md-4">Delivery Term</dt>
                      <dd class="col-md-8">
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="carry" v-model="sales.deliveries[0].delivery_term" :disabled="sales.lock">
                          <label class="form-check-label" for="inlineRadio1">Ambil Sendiri</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="send" v-model="sales.deliveries[0].delivery_term" :disabled="sales.lock">
                          <label class="form-check-label" for="inlineRadio2">Dibawa Sales</label>
                        </div>
                      </dd>
                      <dt class="col-md-4">Print Counter</dt>
                      <dd class="col-md-">
                        {{ sales.print_counter }}
                      </dd>
                      <!-- <dt class="col-md-4">Price List</dt>
                      <dd class="col-md-8">
                        <select v-model="sales.price_id" class="form-control form-control-lite" :disabled="sales.lock">
                          <option value="">-- Price List --</option>
                          <option v-for="p in priceListGroup" :key="p.id" :value="p.id">{{ p.name }}</option>
                        </select>
                      </dd> -->
                    </dl>
                  </div>
                  <div class="col-md-4">
                    <strong class="font-14">Orders:</strong>
                    <span class="ml-2 font-16" style="cursor: pointer; color: #6FB56F" data-toggle="modal" data-target="#modalSalesOrderList" data-backdrop="static" data-keyboard="false" @click="getCustomerOrderList"><i class="fa fa-pencil"></i></span>
                    <span class="ml-2 font-16">
                    </span>
                    <ul v-for="(p, index) in sales.orders" :key="p.id">
                      <li>
                        <span style="cursor: pointer; color: blue;" @click="getOrderNo(p.order_no)" data-toggle="modal" data-target="#modalSaleOrderByNo" data-backdrop="static" data-keyboard="false">
                          {{ p.project_name }}
                        </span>
                        - {{ p.order_date | dateFormat('DD/MM/YYYY') }}
                        - <i>{{ p.order_no }}</i>
                        <span class="ml-2 font-16" style="color: red; cursor: pointer" @click="removeOrder(index)" v-if="sales.lock !== true"><i class="fa fa-trash-o" aria-hidden="true"></i></span>
                      </li>
                    </ul>
                    <hr>
                    <dl class="row dl-custom">
                      <dt class="col-md-4">Tanda Terima</dt>
                      <dd class="col-md-8">
                        <span v-if="loaderTandaTerima === true"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></span>
                        <span v-else><div class="custom-control custom-checkbox"><input type="checkbox" id="canBarcode" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="sales.check_tanda_terima" @change="setTandaTerima"><label for="canBarcode" class="custom-control-label">&nbsp;</label></div></span>
                      </dd>
                      <dt class="col-md-4">Faktur No.</dt>
                      <dd class="col-md-8">{{ sales.faktur_no }}</dd>
                      <dt class="col-md-4">Faktur Date</dt>
                      <dd class="col-md-8">{{ sales.faktur_date | dateFormat('DD/MM/YYYY') }}</dd>
                      <dt class="col-md-4">Faktur Process</dt>
                      <dd class="col-md-8">{{ sales.faktur_process_date | dateFormat('DD/MM/YYYY') }}</dd>
                      <dt class="col-md-4">Notes</dt>
                      <dd class="col-md-8">
                        <textarea v-model="sales.notes" class="form-control" rows="3" :disabled="sales.lock"></textarea>
                      </dd>
                    </dl>
                  </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                    <ul class="nav nav-tabs nav-bordered">
                      <li class="nav-item"><a href="#general" data-toggle="tab" aria-expanded="false" class="nav-link active">Sales</a></li>
                      <li class="nav-item"><a href="#summary" data-toggle="tab" aria-expanded="false" class="nav-link">Summary</a></li>
                      <li class="nav-item"><a href="#payment" data-toggle="tab" aria-expanded="false" class="nav-link">Payment</a></li>
                      <li class="nav-item"><a href="#return" data-toggle="tab" aria-expanded="false" class="nav-link">Retur</a></li>
                      <li class="nav-item"><a href="#journal" data-toggle="tab" aria-expanded="false" class="nav-link">Journal</a></li>
                      <li class="nav-item"><a href="#deliver" data-toggle="tab" aria-expanded="false" class="nav-link">Stock Out</a></li>
                      <li class="nav-item"><a href="#attachment" data-toggle="tab" aria-expanded="false" class="nav-link">Attachment</a></li>
                    </ul>
                    <div class="tab-content">
                      <div class="tab-pane active" id="general">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <table class="table table-sm table-item table-striped">
                                <thead>
                                  <th>Product</th>
                                  <th>Description</th>
                                  <th>Order No.</th>
                                  <th>Qty</th>
                                  <th style="width: 10%">Uom</th>
                                  <th class="text-right">Price</th>
                                  <th class="text-right">Discount</th>
                                  <th class="text-right">%</th>
                                  <th class="text-right">Subtotal(DPP)</th>
                                  <th class="text-right">Tax /item</th>
                                  <th class="text-right">Total Tax</th>
                                  <th class="text-right">Total</th>
                                  <th style="width: 10%">#</th>
                                </thead>
                                <tbody>
                                  <tr v-for="(d, index) in getDataDetails" :key="d.id">
                                    <td>
                                      <p class="input-group">
                                        <input type="text" class="form-control" v-model="d.product_no" disabled="disabled" />
                                        <span class="input-group-btn ml-1">
                                          <button data-toggle="modal" data-target="#modalGetProduct" data-backdrop="static" data-keyboard="false" type="button" class="btn btn-outline-primary btn-sm" @click="setIdDetail(index)" :disabled="sales.lock">
                                            <i class="fa fa-search" aria-hidden="true"></i> Search
                                          </button>
                                        </span>
                                      </p>
                                    </td>
                                    <td>{{ d.description }}</td>
                                    <td>{{ d.order_no }}</td>
                                    <td><input type="text" class="form-control" v-model="d.qty" v-on:keyup="calcRow(index)"/></td>
                                    <td>
                                      <select v-model="d.uom_id" class="form-control" @change="uomRow(index)" disabled="disabled">
                                        <option v-for="u in d.uomList" :value="u.id" :key="u.id">{{ u.name }}</option>
                                      </select>
                                    </td>
                                    <td><input type="text" class="form-control form-control-right" v-model="d.price" v-money="money" v-on:keyup="calcRow(index)"/></td>
                                    <td class="text-right">{{ d.discount | currency }}</td>
                                    <td>
                                      <input type="text" class="form-control form-control-right" v-model="d.discount_percentage" v-on:keyup="calcRow(index)" :disabled="d.lock"/>
                                    </td>
                                    <td class="text-right">{{ d.subtotal | currency }}</td>
                                    <td class="text-right form-table-label">{{ d.tax | currency }}</td>
                                    <td class="text-right form-table-label">{{ d.total_tax | currency }}</td>
                                    <td class="text-right form-table-label">
                                      <span>{{ d.total | currency }}</span> &nbsp;
                                    </td>
                                    <td>
                                      <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removeDetail(index)" :disabled="d.lock"><i class="fa fa-trash"></i></button>
                                      <!-- <button type="button" class="btn btn-sm btn-hard-primary" @click="selectProductToOrder(d.product_no)">
                                        <i class="fa fa-share" aria-hidden="true"></i>
                                      </button> -->
                                      <button type="button" class="btn btn-sm btn-info" @click="moveUp(index)">
                                        <i class="fa fa-arrow-circle-up" aria-hidden="true"></i>
                                      </button>
                                      <button type="button" class="btn btn-sm btn-info" @click="moveDown(index)">
                                        <i class="fa fa-arrow-circle-down" aria-hidden="true"></i>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td>
                                      <span v-show="authUser.permissions.sale_add_product_line">
                                        <span @click="addNewLine" class="link-secondary" v-if="sales.lock === false">+ Add Product</span>
                                      </span>
                                    </td>
                                    <td><span @click="refreshCalc" class="link-secondary" v-if="sales.lock === false">Refresh Total</span></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right">
                                      <!-- <i>{{ getTotalPrice | currency }}</i> -->
                                    </td>
                                    <td class="text-right">
                                      <!-- {{ getTotalDiscount | currency }} -->
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right">
                                    </td>
                                    <td class="text-right">
                                      {{ getTotalTaxDetail | currency }}
                                    </td>
                                    <td></td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="11" class="text-right"><b>Subtotal</b></td>
                                    <td class="text-right">{{ getSubtotal | currency }}</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="11" class="text-right"><b>Discount</b></td>
                                    <td class="text-right">({{ sales.discount | currency }})</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="11" class="text-right"><b>Delivery Cost</b></td>
                                    <td class="text-right">
                                      <input type="text" v-model="sales.delivery_cost" v-money="money" class="form-control form-right" @change="setDeliveryCost">
                                      <span>DPP: {{ deliveryDPP | currency }}</span> | <span>Tax: {{ deliveryTax | currency }}</span>
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="11" class="text-right"><b>DPP</b></td>
                                    <td class="text-right">{{ getTotalDPP | currency }}</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="11" class="text-right"><b>Tax</b></td>
                                    <td class="text-right">{{ sales.tax | currency }}</td>
                                    <td></td>
                                  </tr>
                                  <tr v-if="sales.return_total > 0">
                                    <td colspan="11" class="text-right"><b><i>Retur</i></b></td>
                                    <td class="text-right">{{ sales.return_total | currency }}</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="11" class="text-right"><b>Total</b></td>
                                    <td class="text-right">{{ sales.total | currency }} <span v-if="sales.return_total > 0">({{ totalAfterReturn | currency }})</span></td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="13">&nbsp;</td>
                                  </tr>
                                  <tr>
                                    <td colspan="11" class="text-right"><b>Payment</b></td>
                                    <td class="text-right">{{ totalPayment | currency }}</td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td colspan="11" class="text-right"><b class="text-style"><i>Outstanding</i></b></td>
                                    <td class="text-right">{{ totalOutstanding | currency }}</td>
                                    <td></td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane" id="summary">
                        <div class="table-responsive">
                          <table class="table table-sm table-item table-hover">
                            <thead>
                              <th>Product</th>
                              <th>Qty</th>
                              <th style="width: 10%">Uom</th>
                              <th class="text-right">Price</th>
                              <th class="text-right">Discount</th>
                              <th class="text-right">%</th>
                              <th class="text-right">Subtotal(DPP)</th>
                              <th class="text-right">Tax /item</th>
                              <th class="text-right">Total</th>
                              <th style="width: 10%">#</th>
                            </thead>
                            <tbody>
                              <tr v-for="(g, index) in groupDetail" :key="index">
                                <td><b>[{{ g.product_no }}]</b> {{ g.description }}</td>
                                <td>{{ g.qty }}</td>
                                <td>{{ g.uom_id }}</td>
                                <td class="text-right">{{ g.price | currency }}</td>
                                <td class="text-right">{{ g.discount | currency }}</td>
                                <td class="text-right">{{ g.discount_percentage }}</td>
                                <td class="text-right">{{ g.subtotal | currency }}</td>
                                <td class="text-right">{{ g.tax | currency }}</td>
                                <td class="text-right">{{ g.total | currency }}</td>
                                <td></td>
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colspan="8" class="text-right"><b>Subtotal</b></td>
                                <td class="text-right">{{ getSubtotal | currency }}</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="8" class="text-right"><b>Discount</b></td>
                                <td class="text-right">({{ sales.discount | currency }})</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="8" class="text-right"><b>DPP</b></td>
                                <td class="text-right">{{ getTotalDPP | currency }}</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="8" class="text-right"><b>Tax</b></td>
                                <td class="text-right">{{ sales.tax | currency }}</td>
                                <td></td>
                              </tr>
                              <tr v-if="sales.return_total > 0">
                                <td colspan="8" class="text-right"><b><i>Retur</i></b></td>
                                <td class="text-right">{{ sales.return_total | currency }}</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td colspan="8" class="text-right"><b>Total</b></td>
                                <td class="text-right">{{ sales.total | currency }}</td>
                                <td>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                      <div class="tab-pane" id="payment">
                        <div class="table-responsive">
                          <table class="table table-sm table-item table-striped">
                            <thead>
                              <th>Group</th>
                              <th>Payment No.</th>
                              <th>Date</th>
                              <th>Method</th>
                              <th>Account</th>
                              <th>Note</th>
                              <th class="text-right">Amount</th>
                              <th>#</th>
                            </thead>
                            <tbody>
                              <tr v-for="(p, index) in sales.payments" :key="index">
                                <td>{{ p.group_no }}</td>
                                <td>{{ p.payment_no }}</td>
                                <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                <td>
                                  <span v-if="p.group_no">{{ p.method }}</span>
                                  <span v-else>
                                    <select v-model="p.method_id" class="form-control">
                                      <option v-for="m in methodList" :key="m.id" :value="m.id">{{ m.name }}</option>
                                    </select>
                                  </span>
                                </td>
                                <td>
                                  <span v-if="p.group_no">{{ p.account }}</span>
                                  <span v-else>
                                    <v-select class="vsc-custom" :options="accountSelect" :reduce="account => account.meta.code" label="account" v-model="p.account_code"/>
                                  </span>
                                </td>
                                <td>{{ p.notes }}</td>
                                <td class="text-right">{{ p.price | currency }}</td>
                                <td>
                                  <button class="btn btn-sm btn-soft-primary" v-if="p.group_no === null" @click="setJournalPelunasanPayment(index)">Set Journal</button>
                                </td>
                              </tr>
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right"><b>Total Sales</b></td>
                                <td class="text-right">{{ this.sales.total | currency }}</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right"><b>Total Payment</b></td>
                                <td class="text-right">({{ totalPayment | currency }})</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right"><b class="text-style"><i>Outstanding</i></b></td>
                                <td class="text-right">{{ totalOutstanding | currency }}</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                  <button type="button" class="btn btn-sm btn-soft-primary pull-right" @click="paymentComplete" v-if="totalOutstanding > 0">Payment Complete</button>
                                </td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <!-- <pre>{{ accountSelect }}</pre> -->
                      </div>
                      <div class="tab-pane" id="return">
                        <div class="table-responsive">
                          <table class="table table-sm table-item table-striped">
                            <thead>
                              <th>Return no</th>
                              <th>Return Date</th>
                              <th>Product No.</th>
                              <th>Product</th>
                              <th>Qty</th>
                              <th class="text-right">Amount</th>
                              <th>Tax</th>
                              <th class="text-right">Total</th>
                            </thead>
                            <tbody>
                              <tr v-for="r in dataReturn" :key="r.id">
                                <td>{{ r.return_no }}</td>
                                <td>{{ r.return_date | dateFormat('DD/MM/YYYY') }}</td>
                                <td>{{ r.product_no }}</td>
                                <td>{{ r.product }}</td>
                                <td>{{ r.qty }}</td>
                                <td class="text-right">{{ r.amount }}</td>
                                <td>{{ r.tax }} ({{ r.taxes }})</td>
                                <td class="text-right">{{ r.total }}</td>
                              </tr>
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right">{{ totalReturn | currency }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="tab-pane" id="journal">
                        <div class="table-responsive">
                          <table class="table table-sm table-item table-hover table-striped">
                            <thead>
                              <th>Journal Code</th>
                              <th>Date</th>
                              <th>Account Code</th>
                              <th>Remark</th>
                              <th class="text-right">Debit</th>
                              <th class="text-right">Credit</th>
                            </thead>
                            <tbody>
                              <tr v-for="j in sales.journals" :key="j.id">
                                <td>
                                  <span v-if="j.level === 1">
                                    <b>{{ j.journal_code }} - {{ j.journal_description }}</b>&nbsp;
                                    <span class="badge badge-success" v-if="j.status === 'posted'">{{ j.status }}</span>
                                    <span class="badge badge-warning" v-else-if="j.status === 'draft'">{{ j.status }}</span>
                                  </span>
                                  <span v-else></span>
                                </td>
                                <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                                <td><b>{{ j.account_code }} {{ j.account }}</b></td>
                                <td>{{ j.remark }}</td>
                                <td class="text-right">
                                  <span v-if="j.level === 2">{{ j.debit | currency }}</span>
                                  <span v-if="j.level === 3"><b>{{ j.debit | currency }}</b></span>
                                  <span v-else></span>
                                </td>
                                <td class="text-right">
                                  <span v-if="j.level === 2">{{ j.credit | currency }}</span>
                                  <span v-if="j.level === 3"><b>{{ j.credit | currency }}</b></span>
                                  <span v-else></span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <button type="button" class="btn btn-sm btn-success pull-right" @click="postJournal">Post</button>
                        </div>
                      </div>
                      <div class="tab-pane" id="deliver">
                        <div class="table-responsive">
                          <h5><b>{{ deliveryData.deliver_no }} - {{ deliveryData.deliver_date | dateFormat('DD/MM/YYYY') }}</b></h5>
                          <table class="table table-sm table-item table-hover table-striped">
                            <thead>
                              <th>No</th>
                              <th>Warehouse</th>
                              <th>Product</th>
                              <th>Qty</th>
                              <th>Uom</th>
                              <th></th>
                            </thead>
                            <tbody>
                              <tr v-for="(u, index) in deliverDetailData" :key="u.id">
                                <td>{{ u.queue }}</td>
                                <td>{{ u.warehouse_no }}</td>
                                <td><b>[{{ u.product_no }}]</b> {{ u.product }}</td>
                                <td>{{ u.qty }}</td>
                                <td>{{ u.uom_id }}</td>
                                <td>
                                  <button type="button" class="btn btn-sm btn-info" @click="moveDeliverUp(index)">
                                    <i class="fa fa-arrow-circle-up" aria-hidden="true"></i>
                                  </button>
                                  <button type="button" class="btn btn-sm btn-info" @click="moveDeliverDown(index)">
                                    <i class="fa fa-arrow-circle-down" aria-hidden="true"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!-- <pre>{{ deliveryData }}</pre> -->
                        </div>
                      </div>
                      <div class="tab-pane" id="project">
                        <div class="table-responsive">
                          <table class="table table-sm table-item table-striped">
                            <thead>
                              <th>Status</th>
                              <th>Project No.</th>
                              <th>Project Name</th>
                              <th>Customer</th>
                              <th>Type</th>
                              <th>schedule Date</th>
                              <th>Start Project</th>
                              <th>End Project</th>
                              <th>PIC</th>
                              <th>Engineer</th>
                              <th>#</th>
                            </thead>
                            <tbody>
                              <tr v-for="p in sales.projects" :key="p.project_no">
                                <td>
                                  <span class="badge badge-success" >{{ p.status }}</span>
                                </td>
                                <td>
                                  <span style="color: blue;" @click="toProject(p.id)">{{ p.project_no }}</span>
                                </td>
                                <td>{{ p.project_name }}</td>
                                <td>{{ p.customer.name }}</td>
                                <td>{{ p.type }} </td>
                                <td>{{ p.schedule_date }}</td>
                                <td>{{ p.start_project }}</td>
                                <td>{{ p.end_project }}</td>
                                <td>{{ p.user_pic }}</td>
                                <td>
                                  <ul v-for="e in p.engineers" :key="e.engineer_id">
                                    <li>{{ e.engineer }},</li>
                                  </ul>
                                </td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="tab-pane" id="opex">
                        <div class="table-responsive">
                          <table class="table table-sm table-item table-striped">
                            <thead>
                              <th style="width: 10%">Date</th>
                              <th style="width: 20%">Vendor</th>
                              <th style="width: 10%">Type</th>
                              <th style="width: 10%">Bank</th>
                              <th style="width: 10%">User</th>
                              <th style="width: 10%">Amount</th>
                              <th style="width: 10%">Notes</th>
                              <th></th>
                            </thead>
                            <tbody>
                              <tr v-for="(o, index) in sales.opexs" :key="o.id">
                                <td>
                                  <datetime v-model="o.opex_date" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta"></datetime>
                                </td>
                                <td>
                                  <v-select :options="getVendor" :reduce="vendor => vendor.meta.code" label="vendor" v-model="o.vendor_no"/>
                                </td>
                                <td>
                                  <select v-model="o.type" class="form-control">
                                    <option value="cash">Cash</option>
                                    <option value="transfer">Transfer</option>
                                  </select>
                                </td>
                                <td>
                                  <select v-model="o.bank_id" class="form-control">
                                    <option value="">---</option>
                                    <option v-for="b in bankList" :key="b.id" :value="b.id">{{ b.name }}</option>
                                  </select>
                                </td>
                                <td>
                                  <select v-model="o.user_id" class="form-control">
                                    <option v-for="u in userAll" :key="u.id" :value="u.id">{{ u.name }}</option>
                                  </select>
                                </td>
                                <td><input type="text" v-model="o.amount" v-money="money" class="form-control"/></td>
                                <td>
                                  <textarea v-model="o.notes" class="form-control"/>
                                </td>
                                <td>
                                  <button type="button" class="btn btn-sm btn-danger" @click="removeOpex(index)"><i class="fa fa-trash"></i></button>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <span style="color: blue; cursor: pointer;" @click="addOpex">Add Line</span>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="tab-pane" id="workshop">
                        <div class="table-responsive">
                          <div class="form-inline ml-auto">
                            <div class="button-group">
                              <button type="button" class="btn btn-sm btn-soft-primary pull-right" @click="getWorkshop" data-toggle="modal" data-target="#modalWorkshopList" data-backdrop="static" data-keyboard="false">
                                <i class="fa fa-search"></i> Search
                              </button>
                            </div>
                          </div>
                          <table class="table table-sm table-item table-striped">
                            <thead>
                              <th>Status</th>
                              <th>Workshop No.</th>
                              <th>Customer</th>
                              <th>Mechanic</th>
                              <th>Type</th>
                              <th>Date</th>
                              <th>Start</th>
                              <th>Finish</th>
                              <th>Work Hours</th>
                              <th></th>
                            </thead>
                            <tbody>
                              <tr v-for="(w, index) in sales.workshops" :key="index">
                                <td>
                                  <span class="badge badge-info" v-if="w.status === 'open'">{{ w.status }}</span>
                                  <span class="badge badge-warning" v-else-if="w.status === 'on progress'">{{ w.status }}</span>
                                  <span class="badge badge-success" v-else-if="w.status === 'finish'">{{ w.status }}</span>
                                  <span class="badge badge-danger" v-else-if="w.status === 'void'">{{ w.status }}</span>
                                  <span class="badge badge-secondary" v-else>{{ w.status }}</span>
                                </td>
                                <td><b>{{ w.workshop_no }}</b></td>
                                <td>{{ w.customer.name }}</td>
                                <td>{{ w.mechanic }}</td>
                                <td>{{ w.type }}</td>
                                <td>{{ w.date_in | dateFormat('DD/MM/YYYY') }}</td>
                                <td>{{ w.work_start | dateFormat('DD/MM/YYYY H:m') }}</td>
                                <td>{{ w.work_finish | dateFormat('DD/MM/YYYY H:m') }}</td>
                                <td>{{ w.hours }}</td>
                                <td>
                                  <button type="button" class="btn btn-sm btn-outline-danger" @click="removeWorkshop(index)"><i class="fa fa-trash"></i></button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="tab-pane" id="attachment">
                      </div>
                    </div>
                </div>
              </div>
              <!-- <div class="row" v-show="sales.sale_no !== null">
                  <div class="col-md-12">
                    <h5>Retur</h5>
                    <table class="table table-sm table-item table-stiped">
                      <thead>
                        <th>Date</th>
                        <th>Product</th>
                        <th>Warehouse</th>
                        <th>Qty</th>
                        <th>UoM</th>
                        <th>Serial Number</th>
                        <th>Reason</th>
                        <th>Total</th>
                        <th></th>
                        </thead>
                        <tbody>
                            <tr v-for="d in getRetur" :key="d.id" >
                              <td>{{ d.return_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td>[{{ d.product_no }}] {{ d.description }}</td>
                              <td>
                                <select v-model="d.warehouse_no" id="warehouse" class="form-control">
                                  <option v-for="w in warehouseList" :key="w.id" :value="w.warehouse_no">{{ w.name }}</option>
                                </select>
                              </td>
                              <td><input type="text" v-model="d.qty" class="form-control" v-on:keyup="calcRow(d.id)"/></td>
                              <td>
                                <select v-model="d.uom_id" class="form-control" @change="calcRow(d.id)">
                                  <option v-for="u in d.uomList" :value="u.id" :key="u.id">{{ u.name }}</option>
                                </select>
                              </td>
                              <td>
                                <input type="text" v-model="d.serial_number" class="form-control" v-if="d.products.canBarcode"/>
                                <input type="text" v-model="d.serial_number" class="form-control" v-else disabled="disabled"/>
                              </td>
                              <td><input type="text" v-model="d.reason" class="form-control"/></td>
                              <td>{{ d.total | currency }}</td>
                              <td>
                                <button type="button" class="btn btn-sm btn-danger" @click="deleteRetur(d.id)">
                                  <i class="fa fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
                </div> -->
            </div>
            <div class="card-footer">
            </div>
          </div>
        </div>
        <div :class="card2" v-if="card2 !== null">
          <div class="card card-list">
            <div class="card-header">
              <h5 class="text-primary">
                <span>Order List</span>
              </h5>
            </div>
            <div class="card-body">
              <input type="search" class="form-control" v-model="searchQueryOrder" placeholder="search..."/>
              <div class="table-responsive">
                <table class="table table-sm table-item table-hover table-striped">
                  <thead>
                    <th>SP No</th>
                    <th>Product No.</th>
                    <th>Product name</th>
                    <th>Qty Order</th>
                    <th>Qty Sales</th>
                    <th>Uom</th>
                  </thead>
                  <tbody>
                    <tr v-for="c in customerOrderList" :key="c.id">
                      <td>{{ c.project_name }}</td>
                      <td>{{ c.product_no }}</td>
                      <td>{{ c.product }}</td>
                      <td>{{ c.qty }}</td>
                      <td>{{ c.qty_done }}</td>
                      <td>{{ c.uom_id }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <SalesDetailModal :idDetail="idDetail" :sales="sales" @selectProduct="selectProduct" :amountDue="getTotal"/> -->
      <CustomerFormModal @createCustomer="createCustomer" />
      <CustomerListModal @selectCustomerList="selectCustomerList" />
      <SalesProductModal @selectProduct="selectProduct" :sales="sales" :status="status" :date="sales.sale_date" ref="refreshProduct"/>
      <SaleProjectModal :sales="sales"/>
      <SaleOrderModal @selectTemplate="selectTemplate" @selectOrderMulti="setCustomerOrder"/>
      <SalesRequestModal @getRequestEdit="requestEdit" @getRequestVoid="requestVoid" @getRequestApprove="requestApprove"/>
      <WorkshopListModal @selectWorkshop="selectWorkshop" :date="saleDate"/>
      <SalePrintModal :sales="sales" :group="groupDetail" ref="printPreview"/>
      <!-- <SaleReturModal :detail="detail" @returDetail="returDetail"/> -->
      <!-- <pre>{{ userAll }}</pre> -->
      <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in sales.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-md-6"><pre>{{ sales }}</pre></div> -->
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import CustomerFormModal from '@/components/customer/CustomerFormModal.vue'
import CustomerListModal from '@/components/customer/CustomerListModal.vue'
import SalesProductModal from '@/components/sales/SalesProductModal.vue'
import SaleProjectModal from '@/components/sales/SaleProjectModal.vue'
import SaleOrderModal from '@/components/sales/SaleOrderModal.vue'
import SalesRequestModal from '@/components/sales/SalesRequestModal.vue'
import WorkshopListModal from '@/components/workshop/WorkshopListModal.vue'
import SalePrintModal from '@/components/sales/SalePrintModal.vue'
import { workshopUrl, productUrl, salesUrl, salesDetailUrl, setQtyTotalUrl, getHeader, salesReturUrl, lockUrl, customerUrl, sale2Url, journalUrl, saleOrderUrl, employeeUrl } from '../../config'

export default {
  name: 'SalesForm',
  props: ['sales', 'detailColl'],
  components: {
    CustomerFormModal,
    CustomerListModal,
    SalesProductModal,
    SaleProjectModal,
    SaleOrderModal,
    SalesRequestModal,
    Loading,
    WorkshopListModal,
    SalePrintModal
  },
  created () {
    // Add barcode scan listener and pass the callback function
    console.log('has listener ' + this.$barcodeScanner.hasListener())
  },
  mounted () {
    this.$barcodeScanner.init(this.onBarcodeScanned)
  },
  destroyed () {
    // +Remove listener when component is destroyed
    console.log('Remove listener when component is destroyed')
    this.$barcodeScanner.destroy()
  },
  data () {
    var date = new Date(this.sales.sale_date)
    const saleDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    return {
      loaderTandaTerima: false,
      deliveryDPP: 0,
      deliveryTax: 0,
      alert: [],
      saleDate: saleDate,
      card1: 'col-md-12',
      card2: null,
      searchQueryOrder: '',
      status: 'sales',
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: false,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataPostJournal: {},
      dataSales: {},
      productStatus: null,
      idNew: null,
      idDetail: null,
      detail: null,
      validateCustomerStatus: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      alertCustomer: null,
      customerOutstanding: 0
    }
  },
  computed: {
    ...mapState({
      warehouseList: state => state.warehouses.warehouseList,
      salesTypeList: state => state.sales.salesTypeList,
      branchList: state => state.branches.branchList,
      productList: state => state.products.productList,
      taxList: state => state.taxes.taxList,
      methodList: state => state.payments.methodList,
      uomList: state => state.uom.uomList,
      priceListGroup: state => state.priceLists.priceListGroup,
      userAll: state => state.users.userAll,
      bankList: state => state.banks.bankList,
      vendorList: state => state.vendors.vendorList,
      authUser: state => state.users.authUser,
      termDueList: state => state.termduedates.termDueList,
      companyList: state => state.companies.companyList,
      employeeList: state => state.employees.employeeList,
      customerOutstandingTotal: state => state.customers.customerOutstandingTotal,
      customerOutstandingTotalSales: state => state.customers.customerOutstandingTotalSales,
      customerOutstandingTotalSalePaid: state => state.customers.customerOutstandingTotalSalePaid,
      customerOutstandingDueTotal: state => state.customers.customerOutstandingDueTotal,
      customerPlafondAmount: state => state.customers.customerPlafondAmount,
      customerRatingList: state => state.customers.customerRatingList,
      settingList: state => state.data.settingList,
      chartOfAccountList: state => state.accounts.chartOfAccountList
    }),
    settingDueDatePlafond () {
      let dueDateCount = 0
      const settingPlafond = this.settingList.find(d => d.name === 'customer_sales_plafond_due_date_enable' && d.company_no === this.sales.company_no)
      if (settingPlafond) {
        dueDateCount = settingPlafond.value
      }
      return dueDateCount
    },
    accountSelectCheck () {
      var cmp = this.companyList.find(d => d.company_no === this.sales.company_no)
      var account = []
      if (cmp) {
        // var parentCode = cmp.acc_id + '-111-000'
        // var modalCode = cmp.acc_id + '-310-000'
        // var biayaCode = cmp.acc_id + '-610-000'
        account = this.chartOfAccountList.filter(d => d.company_no === this.sales.company_no).filter(d => d.hierarcy === 3)
      }
      return account
    },
    accountSelect () {
      var loop = []
      var array = []
      array = this.accountSelectCheck
      for (let i = 0; i << array.length; i++) {
        var obj = {
          account: array[i].code + ' - ' + array[i].name,
          meta: {
            code: array[i].code
          }
        }
        loop.push(obj)
      }
      return loop
    },
    isEnablePlafond () {
      let check = false
      const setting = this.settingList.find(d => d.name === 'customer_sales_plafond_enable' && d.company_no === this.sales.company_no)
      if (setting) {
        check = setting.active
      }
      return check
    },
    isEnablePlafondDueDate () {
      let check = false
      const setting = this.settingList.find(d => d.name === 'customer_sales_plafond_due_date_enable' && d.company_no === this.sales.company_no)
      if (setting) {
        check = setting.active
      }
      return check
    },
    isPlafondOke () {
      let check = true
      if (this.isEnablePlafondDueDate) {
        if (parseFloat(this.customerOutstandingDueTotal) > 0) {
          check = false
        }
      } else if (this.isEnablePlafond) {
        if (parseFloat(this.customerOutstandingTotal) >= parseFloat(this.customerPlafondAmount)) {
          check = false
        }
      }
      return check
    },
    totalAfterReturn () {
      var sum = 0
      sum = this.sales.total - this.totalReturn
      return sum
    },
    totalOutstanding () {
      var sum = 0
      sum = this.sales.total - this.totalReturn - this.totalPayment
      return sum
    },
    groupDetailColl () {
      var result = []
      if (this.detailColl.length > 0) {
        this.detailColl.reduce(function (res, value) {
          var key = value.product_no
          var qty = parseFloat(value.qty)
          if (!res[key]) {
            res[key] = {
              product_no: key,
              qty: qty
            }
            result.push(res[key])
          } else {
            res[key].qty = parseFloat(res[key].qty) + qty
          }
          return res
        }, {})
      }
      return result
    },
    groupDetail () {
      var result = []
      if (this.sales.details.length > 0) {
        this.sales.details.reduce(function (res, value) {
          // key = Date.parse(value.cost_date) + value.queue + value.company_no
          var key = value.product_no + value.price
          var price = parseFloat(value.price.replace(/\./g, ''))
          var qty = parseFloat(value.qty)
          var total = (parseFloat(value.subtotal) + parseFloat(value.tax)) * qty
          if (!res[key]) {
            res[key] = {
              sale_no: value.sale_no,
              sale_date: value.sale_date,
              branch_no: value.branch_no,
              product_no: value.product_no,
              product: value.product,
              product_sku: value.product_sku,
              description: value.description,
              barcode: value.barcode,
              qty: qty,
              serial_number: value.serial_number,
              sec_serial_number: value.sec_serial_number,
              uom_id: value.uom_id,
              price: price,
              tax_id: value.tax_id,
              tax: value.tax,
              discount: value.discount,
              discount_percentage: value.discount_percentage,
              subtotal: value.subtotal,
              total: total,
              queue: value.queue,
              warehouse_no: value.warehouse_no,
              edit: value.edit,
              company_no: value.company_no,
              order_no: value.order_no,
              uomList: value.uomList,
              cost: value.cost,
              cost_id: value.cost_id,
              margin: value.margin,
              margin_percentage: value.margin_percentage,
              internal_code: value.internal_code
            }
            result.push(res[key])
          } else {
            res[key].qty = res[key].qty + qty
            res[key].total = res[key].total + total
          }
          return res
        }, {})
      }
      // return result
      var col = 'date'
      var ascending = true
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return result.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    totalReturn () {
      var sum = 0
      var array = this.dataReturn
      for (let a = 0; a < array.length; a++) {
        sum += parseFloat(array[a].total)
      }
      return sum
    },
    totalPayment () {
      var array = this.sales.payments
      var sum = 0
      for (let a = 0; a < array.length; a++) {
        sum += parseFloat(array[a].price)
      }
      return sum
    },
    getDataDetails () {
      var col = 'queue'
      var ascending = true
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.sales.details.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    getEmployeeDriver () {
      var array = this.employeeList.filter(d => d.position === 'Driver')
      var loop = []
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    deliverDetailData () {
      var data = []
      if (this.deliveryData.details.length > 0) {
        var col = 'queue'
        var ascending = true
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        data = this.deliveryData.details.sort(function (a, b) {
          if (a[col] > b[col]) {
            return ascending ? 1 : -1
          } else if (a[col] < b[col]) {
            return ascending ? -1 : 1
          }
          return 0
        })
      }
      return data
    },
    deliveryData () {
      var delivery = this.sales.deliveries[0]
      var obj = {
        id: null,
        deliver_no: delivery.deliver_no,
        sale_no: this.sales.sale_no,
        deliver_date: this.sales.sale_date,
        notes: delivery.notes,
        employee_no: delivery.employee_no,
        type_id: delivery.type_id,
        branch_no: delivery.branch_no,
        company_no: delivery.company_no,
        delivery_term: delivery.delivery_term,
        details: delivery.details
      }
      return obj
    },
    totalDetail () {
      var sum = 0
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalDetailTax () {
      var sum = 0
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].tax)
      }
      return sum
    },
    totalDetailDiscount () {
      var sum = 0
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].discount)
      }
      return sum
    },
    dataReturn () {
      var array = this.sales.returns
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var detail = array[i].details
        for (let z = 0; z < detail.length; z++) {
          var obj = {
            id: detail[z].id,
            return_no: detail[z].return_no,
            product_no: detail[z].product_no,
            product: detail[z].product,
            product_sku: detail[z].product_sku,
            serial_number: detail[z].serial_number,
            uom_id: detail[z].uom_id,
            qty: detail[z].qty,
            amount: detail[z].amount,
            notes: detail[z].notes,
            warehouse_no: detail[z].warehouse_no,
            warehouse: detail[z].warehouse,
            branch_no: detail[z].branch_no,
            company_no: detail[z].company_no,
            discount: detail[z].discount,
            discount_percentage: detail[z].discount_percentage,
            tax_id: detail[z].tax_id,
            tax: detail[z].tax,
            taxes: detail[z].taxes,
            total: detail[z].total,
            return_date: detail[z].return_date,
            cost: detail[z].cost,
            cost_id: detail[z].cost_id
          }
          loop.push(obj)
        }
      }
      return loop
    },
    customerOrderList () {
      var array = this.sales.orders
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var arrDetail = array[i].details
        for (let a = 0; a < arrDetail.length; a++) {
          var obj = {
            id: arrDetail[a].id,
            order_no: array[i].order_no,
            order_date: array[i].order_date,
            project_name: array[i].project_name,
            product_no: arrDetail[a].product_no,
            product: arrDetail[a].description,
            qty: arrDetail[a].qty,
            qty_done: arrDetail[a].qty_done,
            uom_id: arrDetail[a].uom_id
          }
          loop.push(obj)
        }
      }
      return loop.filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQueryOrder.toLowerCase()) > -1) {
              return d
            }
          }
        }
      })
    },
    getTotalPrice () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.replace(/\./g, ''))
      }
      return sum
    },
    getTotalDiscount () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].discount.replace(/\./g, ''))
      }
      return sum
    },
    getTotalDPP () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var dpp = array[i].subtotal
        sum += parseFloat(array[i].qty) * parseFloat(dpp)
      }
      return sum + this.deliveryDPP
    },
    getTotalTax () {
      var array = this.sales.details
      var sum = 0
      var tax = this.taxList.find(d => d.id === this.sales.tax_id)
      if (tax) {
        for (let i = 0; i < array.length; i++) {
          var taxAmount = 0
          if (tax.include === false) {
          } else {
            if (tax.amount === '11') {
              // Old
              taxAmount = parseFloat(array[i].subtotal) * 11 / 100
              sum += parseFloat(array[i].qty) * taxAmount
            } else {
              taxAmount = parseFloat(array[i].subtotal) * 10 / 100
              sum += parseFloat(array[i].qty) * taxAmount
            }
          }
        }
      }
      var totalTax = parseFloat(this.deliveryTax) + Math.round(sum)
      return totalTax
    },
    getTotalTaxDetail () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].tax)
      }
      return Math.round(sum)
    },
    getTotalDetail () {
      var sum = 0
      sum = this.getTotalDPP + this.getTotalTax
      return sum
    },
    getAmountDue: function () {
      var total = this.sales.total - this.getTotalPaid
      return total
    },
    paymentList: function () {
      return this.sales.payments.filter(d => d.id !== null)
    },
    getNetProfit: function () {
      var total = this.getGrossProfit - this.getOpex
      return total
    },
    getNetProfitPercentage: function () {
      var total = 0
      total = (this.getNetProfit / parseFloat(this.getTotal)) * 100
      return Math.ceil(total)
    },
    getOpex: function () {
      var sum = 0
      var array = this.sales.opexs
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].amount.replace(/\./g, ''))
      }
      return sum.toString()
    },
    getGrossProfit: function () {
      var total = 0
      total = parseFloat(this.getTotal) - parseFloat(this.getTotalCost)
      return total
    },
    getGrossProfitPercentage: function () {
      var total = 0
      total = (this.getGrossProfit / parseFloat(this.getTotal)) * 100
      return Math.ceil(total)
    },
    getTotalCost: function () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].cost.replace(/\./g, '')) * parseFloat(array[i].qty)
      }
      return sum.toString()
    },
    getTotalMargin: function () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].margin) * parseFloat(array[i].qty)
      }
      return sum.toString()
    },
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = []
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getUserDeliveryman: function () {
      var array = this.employeeList
      var loop = []
      for (let a = 0; a < array.length; a++) {
        var obj = {
          deliver: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getVendor: function () {
      var array = this.vendorList
      var loop = [{
        vendor: '---',
        meta: {
          code: null
        }
      }]
      for (let i = 0; i < array.length; i++) {
        var obj = {
          vendor: array[i].name,
          meta: {
            code: array[i].vendor_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getTotalRetur: function () {
      var array = this.sales.returs
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += array[i].total
      }
      return sum
    },
    getRetur: function () {
      return this.sales.returs.filter(d => d.id !== null)
    },
    getWarehouseBranch: function () {
      if (this.sales.branch_no !== null) {
        return this.warehouseList.filter(d => d.branch_no === this.sales.branch_no)
      } else {
        return this.warehouseList
      }
    },
    salesDetail: function () {
      return this.sales.details.filter(d => d.id !== null)
    },
    getSubtotal: function () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].price !== '0') {
          sum += parseFloat(array[i].price.replace(/\./g, '')) * parseFloat(array[i].qty)
        }
      }
      return sum
    },
    getSubtotal2: function () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var amount = parseFloat(array[i].total)
        sum += amount
      }
      return sum
    },
    getTax: function () {
      var subtotal = this.getSubtotal
      var discount = parseFloat(this.sales.discount.replace(/\./g, ''))
      var taxId = this.sales.tax_id
      var taxAmount = 0
      var taxLis = this.taxList.find(d => d.id === taxId)
      if (taxLis) {
        if (taxLis.include === false) {
          taxAmount = (subtotal - discount) * (parseInt(taxLis.amount) / 100)
          return taxAmount.toString()
        } else {
          return '0'
        }
      } else {
        return '0'
      }
    },
    getTotalPaid: function () {
      var sum = 0
      var array = this.sales.payments
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.replace(/\./g, ''))
      }
      return sum
    },
    getRemaining: function () {
      var total = this.sales.total
      var paid = this.getTotalPaid
      var remaining = total - paid
      return remaining
    }
  },
  methods: {
    async currencyFilter (value) {
      if (value === null) {
        return '0'
      } else if (typeof value === 'string') {
        return parseFloat(value).toLocaleString('id-ID')
      } else {
        return parseFloat(value).toLocaleString('id-ID')
      }
    },
    async setJournalPelunasanPayment (index) {
      const payment = this.sales.payments[index]
      console.log(payment)
      await axios.put(salesUrl + '/payment/' + payment.id, payment, { headers: getHeader() })
        .then(response => {
          this.$swal('Payment', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Payment', error.response.data.message, 'error')
          throw error
        })
      if (!payment) {
        this.$swal('Error', 'Payment data not found', 'error')
        return false
      }
      const data = {
        id: payment.id,
        account_code: payment.account_code
      }
      await axios.post(salesUrl + '/set-journal-pelunasan', data, { headers: getHeader() })
        .then(response => {
          this.$swal('Journal', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Journal', error.response.data.message, 'error')
          throw error
        })
    },
    async setTandaTerima () {
      if (this.sales.id !== null) {
        this.loaderTandaTerima = true
        var body = {
          id: this.sales.id
        }
        console.log(body)
        await axios.post(salesUrl + '/check-tanda-terima', body, { headers: getHeader() })
          .then(response => {
            console.log(response.data.data)
            const data = response.data.data
            this.sales.check_tanda_terima = data.check_tanda_terima
            this.loaderTandaTerima = false
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Sales', error.response.data.message, 'error')
            this.sales.check_tanda_terima = false
            this.loaderTandaTerima = false
            throw error
          })
      }
    },
    async resetPrintCounter () {
      await axios.post(salesUrl + '/reset-printer-counter', this.sales, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Sales', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async setDeliveryCost () {
      var deliveryCost = this.sales.delivery_cost.replace(/\./g, '')
      var tax = this.taxList.find(d => d.id === this.sales.tax_id)
      if (tax) {
        var dpp = 0
        var taxAmount = 0
        if (tax.include === false) {
          taxAmount = deliveryCost * tax.amount / 100
          dpp = deliveryCost
        } else {
          if (tax.amount === '0') {
            taxAmount = 0
            dpp = deliveryCost
          } else {
            if (tax.amount === '11') {
              dpp = deliveryCost / 1.11
              taxAmount = Math.round(dpp) * 0.11
            } else {
              dpp = deliveryCost / 1.1
              taxAmount = Math.round(dpp) * 0.1
            }
          }
        }
        this.deliveryDPP = Math.round(dpp)
        this.deliveryTax = Math.round(taxAmount)
        this.sales.tax = this.getTotalTax
        this.sales.total = this.getTotalDPP + this.getTotalTax
      }
    },
    async getCustomerOutstanding () {
      var data = {
        customer_no: this.sales.customer_no,
        date: this.sales.sale_date
      }
      await this.$store.dispatch('getCustomerOutstadingTotal', data)
    },
    async selectWorkshop (value) {
      for (let i = 0; i < value.length; i++) {
        await axios.get(workshopUrl + '/' + value[i], { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            this.sales.workshops.push(response.data.data)
            var data = response.data.data.details
            var count = 0
            for (let a = 0; a < data.length; a++) {
              count += 1
              var obj = {
                sale_no: this.sales.sale_no,
                sale_date: this.sale_date,
                branch_no: this.sales.branch_no,
                company_no: this.sales.company_no,
                product_no: data[a].product_no,
                product_sku: data[a].product_sku,
                description: data[a].description,
                qty: data[a].qty,
                serial_number: data[a].serial_number,
                sec_serial_number: data[a].sec_serial_number,
                uom_id: data[a].uom_id,
                price: '0',
                tax_id: this.sales.tax_id,
                tax: '0',
                total_tax: '0',
                discount: '0',
                discount_percentage: '0',
                subtotal: '0',
                total: '0',
                queue: count,
                warehouse_no: this.sales.warehouse_no,
                state: 'create',
                edit: false,
                uomList: data[a].uomList,
                cost: '0',
                cost_id: null,
                margin: '0',
                margin_percentage: '0',
                internal_code: null
              }
              this.sales.details.push(obj)
              this.sales.customer_no = response.data.data.customer_no
              this.sales.customer = response.data.data.customer
              this.state = 'create'
            }
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    getWorkshop () {
      var date = new Date(this.sales.sale_date)
      const saleDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      var payload = {
        begin: saleDate,
        end: saleDate,
        company: null
      }
      console.log(payload)
      this.$store.dispatch('getWorkshopList', payload)
    },
    async removeWorkshop (index) {
      var wo = this.sales.workshops[index]
      console.log(wo)
      if (wo.sale_no === null) {
        this.sales.workshops.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
          }
        })
      }
    },
    async paymentComplete () {
      var obj = {
        payment_no: null,
        sale_no: this.sales.sale_no,
        payment_date: new Date().toISOString(),
        price: this.totalOutstanding,
        method_id: null,
        type_id: null,
        bank_id: null,
        notes: '[pelunasan by system]',
        lock: false,
        status: null,
        journal_code: null,
        prepayment_date: null,
        group_no: null,
        account_code: null,
        report_no: null,
        finish: true,
        commission_id: null,
        commission_amount: null,
        commission_percentage: null
      }
      var resp = {
        error: false,
        message: null
      }
      console.log(obj)
      await axios.post(salesUrl + '/payment', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          resp.error = false
          resp.message = response.data.message
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      if (resp.error === false) {
        await this.$swal('Success', resp.message, 'success')
        await this.$emit('backClickID', this.sales.id)
      }
    },
    async requestVoid (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.sales.sale_no,
        lock_note: value,
        type: 'sales-void'
      }
      console.log(obj)
      await axios.post(lockUrl, obj, { headers: getHeader() })
        .then(response => {
          this.$swal('Lock', 'Sales has been requested (' + this.sales.sale_no + ')', 'success')
          // this.$emit('backClicked')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async requestApprove (value) {
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.sales.sale_no,
        lock_note: value,
        type: 'sales-approve'
      }
      console.log(obj)
      await axios.post(lockUrl, obj, { headers: getHeader() })
        .then(response => {
          this.$swal('Lock', 'Sales has been requested (' + this.sales.sale_no + ')', 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async unlock () {
      var body = {
        id: this.sales.id
      }
      await this.$swal.fire({
        title: 'Are you sure unlock this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#28A745',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Unlock it!'
      }).then((result) => {
        if (result.value) {
          console.log(salesUrl + '/unlock')
          axios.post(salesUrl + '/unlock', body, { headers: getHeader() })
            .then(response => {
              console.log(response.data.message)
              this.$swal('Success', response.data.message, 'success')
              // this.$emit('backClicked')
              this.backParent()
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async checkDate () {
      var date1 = new Date()
      date1.setHours(0, 0, 0, 0)
      var date2 = new Date(this.sales.sale_date)
      date2.setHours(0, 0, 0, 0)
      var remaining = date2.getTime() - date1.getTime()
      var diffInDay = remaining / (1000 * 3600 * 24)
      console.log('Diff in a day ' + diffInDay)
      if (diffInDay > 1) {
        this.$swal('Error', 'Tanggal tidak boleh lebih dari hari ini (' + diffInDay + ' hari)', 'error')
        this.sales.sale_date = date1
      } else if (Math.abs(diffInDay) > 2) {
        this.$swal('Error', 'Tanggal tidak boleh kurang dari 2 hari', 'error')
        this.sales.sale_date = date1
      }
    },
    async removeSales () {
      var resp = {
        error: false,
        message: null
      }
      await this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$Progress.start()
          this.loader.isLoading = true
          axios.delete(salesUrl + '/' + this.sales.id, { headers: getHeader() })
            .then(response => {
              console.log(response.data.message)
              resp.error = true
              resp.message = response.data.message
            })
            .catch(error => {
              this.$Progress.fail()
              this.loader.isLoading = false
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
      await this.$Progress.finish()
      this.loader.isLoading = false
      // Begin Second process
      await this.$swal('Process', 'Update Kartu Stock', 'success')
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.syncOrderAll('no reply')
      await this.setCOGSAll()
      await this.$Progress.finish()
      this.loader.isLoading = false
      // End Second process
      await this.$swal('Success', resp.message, 'success')
      await this.backParent()
      this.alert = []
    },
    setTypeSales () {
      if (this.sales.type_id === 1 || this.sales.type_id === 5) {
        var salesType = this.salesTypeList.find(d => d.id === this.sales.type_id)
        console.log(salesType)
        this.sales.term_due_id = salesType ? salesType.term_due_date_id : null
      }
    },
    async refreshCalc () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        await this.calcRow([i])
      }
      console.log('success refresh calcrow')
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async setJournalReturn () {
      const id = this.sales.returs[0].id
      if (id) {
        var resp = {
          error: false,
          message: ''
        }
        await axios.get(salesUrl + '/journal-return/' + id, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error.response)
            resp.error = true
            resp.message = error.response.data.message
            throw error
          })
        await axios.get(salesUrl + '/journal-return-stock/' + id, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error.response)
            resp.error = true
            resp.message = error.response.data.message
            throw error
          })
        if (resp.error) {
          this.$swal('Error', resp.message, 'error')
        } else {
          await this.$swal('Success', resp.message, 'success')
          this.$emit('backClickID', this.sales.id)
        }
      }
    },
    async setJournalAll () {
      await this.setJournalSingle()
      await this.setJournalDeliveryCost()
      await this.setJournalStockSingle()
    },
    moveDeliverUp (index) {
      var current = index
      var before = index - 1
      var currentData = {}
      var beforeData = {}
      if (current < 0) {
      } else {
        currentData = this.deliveryData.details[current]
        beforeData = this.deliveryData.details[before]
        if (currentData.queue === 1) {
        } else {
          console.log(currentData.queue)
          console.log(beforeData.queue)
          currentData.queue = currentData.queue - 1
          beforeData.queue = beforeData.queue + 1
        }
      }
    },
    moveDeliverDown (index) {
      var current = index
      var next = index + 1
      var currentData = {}
      var nextData = {}
      if (current < 0) {
      } else {
        currentData = this.deliveryData.details[current]
        nextData = this.deliveryData.details[next]
        if (currentData.queue === this.deliveryData.details.length) {
        } else {
          currentData.queue = currentData.queue + 1
          nextData.queue = nextData.queue - 1
        }
      }
    },
    moveUp (index) {
      var current = index
      var before = index - 1
      var currentData = {}
      var beforeData = {}
      console.log(current)
      if (current < 0) {
      } else {
        currentData = this.sales.details[current]
        beforeData = this.sales.details[before]
        if (currentData.queue === 1) {
        } else {
          currentData.queue = currentData.queue - 1
          beforeData.queue = beforeData.queue + 1
        }
      }
    },
    moveDown (index) {
      var current = index
      var next = index + 1
      var currentData = {}
      var nextData = {}
      if (current < 0) {
      } else {
        currentData = this.sales.details[current]
        nextData = this.sales.details[next]
        if (currentData.queue === this.sales.details.length) {
        } else {
          currentData.queue = currentData.queue + 1
          nextData.queue = nextData.queue - 1
        }
      }
    },
    removeOrderAll () {
      if (this.sales.id === null) {
        this.sales.orders = []
        this.sales.details = []
      }
    },
    getCustomerOrderList () {
      var payload = {
        customer_no: this.sales.customer_no,
        company_no: this.sales.company_no,
        salesman_id: this.sales.salesman_id
      }
      this.$store.dispatch('getCustomerOrderList', payload)
    },
    async removeOrder (index) {
      var order = this.sales.orders[index]
      var array = this.sales.details.filter(d => d.order_no === order.order_no)
      for (let i = 0; i < array.length; i++) {
        var pdID = this.sales.details.findIndex(d => d.order_no === array[i].order_no)
        this.sales.details.splice(pdID, 1)
      }
      await this.sales.orders.splice(index, 1)
    },
    selectProductToOrder (product) {
      if (this.searchQueryOrder === null || this.searchQueryOrder === '') {
        this.searchQueryOrder = product
        this.card1 = 'col-md-8'
        this.card2 = 'col-md-4'
      } else if (this.searchQueryOrder === product) {
        if (this.searchQueryOrder !== product) {
          this.searchQueryOrder = ''
        } else {
          this.searchQueryOrder = ''
        }
        this.card1 = 'col-md-12'
        this.card2 = null
      }
    },
    async getOrderNo (order) {
      var payload = {
        order_no: order
      }
      console.log(payload)
      this.$store.dispatch('getOrderByNo', payload)
    },
    async getCustomerOrder () {
      if (this.sales.company_no === null || this.sales.company_no === '') {
        this.$swal(
          'Error',
          'Data company harus diisi',
          'error'
        )
        return false
      }
      if (this.sales.salesman_id === null || this.sales.salesman_id === '') {
        this.$swal(
          'Error',
          'Data salesman harus diisi',
          'error'
        )
        return false
      }
      this.$Progress.start()
      this.loader.isLoading = true
      this.sales.details = []
      var data = {
        customer_no: this.sales.customer_no,
        company_no: this.sales.company_no,
        salesman_id: this.sales.salesman_id
      }
      await axios.post(customerUrl + '/order', data, { headers: getHeader() })
        .then(response => {
          var array = response.data.data
          this.sales.orders = array
          for (let i = 0; i < array.length; i++) {
            var arr = array[i].details
            var no = 0
            for (let a = 0; a < arr.length; a++) {
              no += 1
              var sd = this.sales.details.find(d => d.product_no === arr[a].product_no)
              if (sd) {
                sd.qty += arr[a].qty
              } else {
                var obj = {
                  sales_no: this.sales.sales_no,
                  sale_date: this.sales.sale_date,
                  branch_no: this.sales.branch_no,
                  product_no: arr[a].product_no,
                  product_sku: arr[a].product_sku,
                  description: arr[a].description,
                  qty: arr[a].qty,
                  serial_number: null,
                  sec_serial_number: null,
                  uom_id: arr[a].uom_id,
                  price: arr[a].price,
                  tax_id: arr[a].tax_id,
                  tax: arr[a].tax,
                  discount: arr[a].discount === null ? '0' : arr[a].discount,
                  discount_percentage: arr[a].discount === null ? '0' : arr[a].discount_percentage,
                  subtotal: arr[a].subtotal,
                  total: arr[a].total,
                  queue: no,
                  warehouse_no: this.sales.warehouse_no,
                  cost: '0',
                  cost_id: null,
                  margin: '0',
                  margin_percentage: '0',
                  internal_code: null
                }
              }
              this.sales.details.push(obj)
            }
          }
          this.setTax()
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          this.$Progress.finish()
          this.loader.isLoading = false
        })
      await this.setTax()
    },
    async setCustomerOrder (value) {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = value
      var coll = []
      for (let i = 0; i < array.length; i++) {
        this.sales.orders.push(value[i])
        var arr = array[i].details
        var no = 0
        for (let a = 0; a < arr.length; a++) {
          no += 1
          var qtyOutstading = parseFloat(arr[a].qty) - parseFloat(arr[a].qty_done)
          if (qtyOutstading > 0) {
            var uomList = []
            var qtyTotal = 0
            var body = {
              product_no: arr[a].product_no
            }
            await axios.post(productUrl + '/uom/list', body, { headers: getHeader() })
              .then(response => {
                uomList = response.data.data
                qtyTotal = response.data.qty_total
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
              })
            var obj = {
              sales_no: this.sales.sales_no,
              sale_date: this.sales.sale_date,
              branch_no: this.sales.branch_no,
              product_no: arr[a].product_no,
              product_sku: arr[a].product_sku,
              description: arr[a].description,
              qty: qtyOutstading,
              serial_number: null,
              sec_serial_number: null,
              uom_id: arr[a].uom_id,
              price: arr[a].price,
              tax_id: arr[a].tax_id,
              tax: arr[a].tax,
              discount: arr[a].discount === null ? '0' : arr[a].discount,
              discount_percentage: arr[a].discount === null ? '0' : arr[a].discount_percentage,
              subtotal: arr[a].subtotal,
              total: arr[a].total,
              queue: no,
              warehouse_no: this.sales.warehouse_no,
              cost: '0',
              cost_id: null,
              margin: '0',
              margin_percentage: '0',
              internal_code: null,
              order_no: arr[a].order_no,
              uomList: uomList,
              lock: false
            }
            console.log('qtyTotal:' + qtyTotal)
            this.sales.details.push(obj)
          }
        }
      }
      if (coll.length > 0) {
        var words = ''
        var header = ''
        for (let c = 0; c < coll.length; c++) {
          header = coll[c].message
          words = words + '- <b>[' + coll[c].pNo + ']</b> ' + coll[c].pName + '<br>'
        }
        console.log(words)
        this.$swal(header, words, 'error')
      }
      this.setTax()
      this.$Progress.finish()
      this.loader.isLoading = false
    },
    async requestEdit (value) {
      const printCount = parseFloat(this.sales.print_counter)
      let note = null
      if (printCount > 4) {
        note = value + ' print counter (' + printCount + ')'
      } else {
        note = value
      }
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.sales.sale_no,
        lock_note: note,
        type: 'sales'
      }
      console.log(obj)
      await axios.post(lockUrl, obj, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Lock',
            'Sales has been requested',
            'success'
          )
          // this.$emit('backClicked')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
        })
    },
    async approvePermission () {
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.updateSales('no reply')
      // start process
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.approveSales()
      // start process
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.setJournalAll()
      // end process
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async approveAll () {
      await this.validateCustomer()
      if (this.validateCustomerStatus) {
        return false
      }
      await this.updateSales('no reply')
      await this.approveSales()
      await this.setCOGSAll('no reply')
      await this.setJournalAll()
    },
    async setCOGSAll (reply) {
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        var date = new Date(this.sales.sale_date)
        var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
        var data = {
          date: newDate,
          product_no: array[i].product_no,
          type: 'all',
          company_no: this.sales.company_no
        }
        var resp = {
          error: false,
          message: null
        }
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
          })
      }
    },
    async setCOGS () {
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        var date = new Date(this.sales.sale_date)
        var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
        var data = {
          date: newDate,
          product_no: array[i].product_no,
          type: 'sales',
          company_no: this.sales.company_no
        }
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log('success sync cogs')
            console.log(response.data.data)
            this.$swal('Success', response.data.message, 'success')
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    async setJournalSingle () {
      await axios.get(salesUrl + '/journal/' + this.sales.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClickID', this.sales.id)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async setJournal () {
      await axios.get(salesUrl + '/journal/' + this.sales.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    async setJournalPaymentSingle () {
      await axios.get(salesUrl + '/journal-payment/' + this.sales.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClickID', this.sales.id)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async setJournalPayment () {
      await axios.get(salesUrl + '/journal-payment/' + this.sales.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    async setJournalStockSingle () {
      await axios.get(salesUrl + '/journal-stock-out/' + this.sales.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backClickID', this.sales.id)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    async setJournalDeliveryCost () {
      await axios.get(salesUrl + '/journal-deliver-cost/' + this.sales.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backClickID', this.sales.id)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    async setJournalStock () {
      await axios.get(salesUrl + '/journal-stock-out/' + this.sales.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    async postJournal () {
      var array = this.sales.journals.filter(d => d.level === 1)
      for (let i = 0; i < array.length; i++) {
        var data = {
          id: array[i].id
        }
        await axios.post(journalUrl + '/posting', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            return false
          })
      }
      await this.$swal('Success', 'Success Post All Journal', 'success')
      await this.$emit('backClickID', this.sales.id)
    },
    async approveSales () {
      await axios.put(salesUrl + '/approve/' + this.sales.id, this.sales, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backParentID', this.sales.id)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    async setQtyTotal (code) {
      var d = new Date()
      var n = d.getFullYear()
      var n1 = n - 1
      this.year = [n1, n]
      var newYear = d.getFullYear()
      var newMonth = d.getMonth() + 1
      var newDate = d.getDate()
      var newSetDate = newYear + '-' + newMonth + '-' + newDate
      var comNo = this.sales.company_no

      await axios.get(setQtyTotalUrl + '?end=' + newSetDate + '&available=true&company_no=' + comNo + '&product_no=' + code, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
        })
        .catch(error => {
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    editPayment: function (id) {
      this.idNew = id
      var pay = this.sales.payments.find(d => d.id === id)
      pay.state = 'edit'
    },
    backToPayment: function (id) {
      var pay = this.sales.payments.find(d => d.id === id)
      if (pay.state === 'new') {
        var index = this.sales.payments.findIndex(d => d.id === id)
        this.sales.payments.splice(index, 1)
      }
    },
    addNewPayment: function () {
      this.idNew = Math.floor(Math.random() * (99999999 - 66666666) + 66666666)
      var obj = {
        id: this.idNew,
        payment_date: null,
        price: this.getAmountDue.toString(),
        method_id: null,
        method: null,
        type_id: null,
        type: null,
        bank_id: null,
        bank: null,
        account_no: null,
        notes: null,
        state: 'new'
      }
      this.sales.payments.push(obj)
    },
    selectTemplate: function (tmp) {
      console.log(tmp)
      this.sales.details = []
      var array = tmp.details
      var tax = this.taxList.find(d => d.id === this.sales.tax_id)
      var queue = 0
      for (let i = 0; i < array.length; i++) {
        queue += 1
        console.log(array[i].product_no)
        var value = this.productList.find(d => d.product_no === array[i].product_no)
        console.log(value)
        var dpp = value.price
        var totalTax = dpp * 10 / 100
        if (tax.include === false) {
          totalTax = dpp * tax.amount / 100
        } else {
          totalTax = 0
        }
        var obj = {
          sales_no: null,
          sale_date: null,
          branch_no: this.sales.branch_no,
          product_no: value.product_no,
          description: value.product_name,
          qty: array[i].qty,
          serial_number: null,
          uom_id: value.uom_id,
          price: value.price,
          tax_id: this.sales.tax_id,
          tax: totalTax,
          discount: '0',
          total: value.price,
          queue: queue,
          warehouse_no: null,
          state: 'create',
          edit: false,
          uomList: value.uomList,
          cost: value.product_cost.toString(),
          cost_id: value.cost_id,
          margin: '0',
          margin_percentage: '0',
          internal_code: null
        }
        this.sales.details.push(obj)
      }
    },
    getType: function () {
      // var styp = this.salesTypeList.find(d => d.id === this.sales.type_id)
      var date = new Date(this.sales.sale_date)
      var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
      var obj = {
        priceID: this.sales.price_id,
        branch: this.sales.branch_no,
        warehouse: this.sales.warehouse_no,
        date: newDate
      }
      // this.sales.details = []
      console.log(obj)
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    getProductList: function () {
      var date = new Date(this.sales.sale_date)
      var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
      var obj = {
        priceID: this.sale.price_id,
        branch: this.sale.branch_no,
        warehouse: this.sale.warehouse_no,
        date: newDate
      }
      console.log(obj)
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    removeOpex (index) {
      var detail = this.sales.opexs[index]
      if (detail.state === 'create') {
        this.sales.opexs.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(salesUrl + '/opex/' + detail.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                this.sales.opexs.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    addOpex: function () {
      var obj = {
        sale_no: null,
        amount: '0',
        opex_date: null,
        type: null,
        bank_id: null,
        user_id: null,
        notes: null,
        state: 'create'
      }
      this.sales.opexs.push(obj)
    },
    toProject: function (id) {
      this.$router.push({ name: 'project', query: { id: id, ref: this.sales.id } })
    },
    returDetail: function (value) {
      var detail = this.sales.details.find(d => d.id === value.idDetil)
      var newID = Math.floor(Math.random() * (99999999 - 66666666) + 66666666)
      var obj = {
        id: newID,
        sale_no: this.sales.sale_no,
        return_date: value.return_date,
        branch_no: this.sales.branch_no,
        product_no: detail.product_no,
        product: detail.product,
        products: detail.products,
        description: detail.description,
        internal_code: detail.barcode,
        qty: value.qty,
        qty_done: null,
        serial_number: value.serial_number,
        uom_id: detail.uom_id,
        price: detail.price,
        tax_id: detail.tax_id,
        tax: detail.tax,
        discount: detail.discount,
        total: value.qty * detail.price,
        queue: null,
        warehouse_no: detail.warehouse_no,
        reason: value.reason,
        uomList: detail.uomList,
        state: 'create'
      }
      console.log(obj)
      this.sales.returs.push(obj)
      if (value.change) {
        detail.qty = detail.qty - value.qty
        this.calcRow(detail.id)
        if (detail.qty <= 0) {
          this.removeDetail(value.idDetil)
        }
      }
    },
    async sendNotif (id) {
      var obj = {
        id: id
      }
      await axios.post(salesUrl + '/notif', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          this.$swal(
            'Success',
            'Succes send notif to Whatsapp',
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            'Cannot send notif',
            'error'
          )
        })
    },
    calcRowPrice: function (id) {
      var detail = this.sales.details.find(d => d.id === id)
      detail.total = parseFloat(detail.qty) * parseFloat(detail.price.replace(/\./g, ''))
    },
    uomRow (index) {
      var detail = this.sales.details[index]
      detail.price = 0
      detail.qty = 0
      detail.dicount = 0
      detail.tax = 0
      detail.total = 0
      var uom = detail.uomList.find(d => d.id === detail.uom_id)
      console.log(uom)
      var price = 0
      if (uom.category_id === 3) {
        price = parseFloat(uom.price)
      } else if (uom.category_id === 1) {
        price = parseFloat(uom.price) * parseFloat(uom.ratio)
      } else {
        price = parseFloat(uom.price) / parseFloat(uom.ratio)
      }
      detail.price = price.toString()
    },
    checkTax: function () {
      var cmp = this.companyList.find(d => d.company_no === this.sales.company_no)
      this.sales.tax_id = cmp.tax_id
      this.setTax()
    },
    calcRow (index) {
      var detail = this.sales.details[index]
      var qty = detail.qty
      var amount = parseFloat(detail.price.toString().replace(/\./g, ''))
      var order = this.sales.orders.find(d => d.order_no === detail.order_no)
      var qtyDone = 0
      if (order) {
        var orderDetail = order.details.find(d => d.product_no === detail.product_no)
        var orderPrice = orderDetail.price.replace(/\./g, '')
        qtyDone = orderDetail.qty
      }
      console.log(qty + '><' + qtyDone)
      console.log(amount + '><' + orderPrice)
      if (parseFloat(amount) === parseFloat(orderPrice)) {
        if (parseFloat(qty) > parseFloat(qtyDone)) {
          detail.qty = qtyDone
          this.$swal('Error', 'Quantity cannot greater than order', 'error')
          return false
        }
      }
      var discountPercentage = this.sales.details[index].discount_percentage === '' ? 0 : parseFloat(this.sales.details[index].discount_percentage)
      console.log(discountPercentage)
      var discount = amount * discountPercentage / 100
      var subtotal = amount - discount
      var tax = this.taxList.find(d => d.id === this.sales.tax_id)
      var dpp = 0
      var taxAmount = 0
      var totalTaxAmount = 0
      if (tax.include === false) {
        taxAmount = subtotal * tax.amount / 100
        dpp = subtotal
      } else {
        if (tax.amount === '0') {
          taxAmount = 0
          dpp = subtotal
        } else {
          if (tax.amount === '11') {
            dpp = subtotal / 1.11
            taxAmount = Math.round(dpp) * 0.11
            totalTaxAmount = detail.qty * (Math.round(dpp) * 11 / 100)
          } else {
            dpp = subtotal / 1.1
            taxAmount = Math.round(dpp) * 0.1
            totalTaxAmount = detail.qty * (Math.round(dpp) * 10 / 100)
          }
        }
      }
      this.sales.details[index].discount = discount.toString()
      this.sales.details[index].subtotal = Math.round(dpp)
      this.sales.details[index].tax = taxAmount
      this.sales.details[index].total_tax = Math.round(totalTaxAmount)
      var totalDetailRow = (this.sales.details[index].subtotal + this.sales.details[index].tax) * qty
      this.sales.details[index].total = totalDetailRow
      console.log('Total: ' + totalDetailRow)
      // this.sales.details[index].subtotal = dpp
      // this.sales.details[index].tax = taxAmount
      // this.sales.details[index].total = (dpp + taxAmount) * qty

      this.sales.discount = this.totalDetailDiscount
      this.sales.subtotal = this.totalDetailSubtotal
      this.sales.tax = this.getTotalTax
      this.sales.total = this.getTotalDPP + this.getTotalTax
    },
    setTotalDiscount: function () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        // sum += parseFloat(array[i].discount) * parseFloat(array[i].qty)
        sum += parseFloat(array[i].discount.replace(/\./g, '')) * parseFloat(array[i].qty)
      }
      return sum.toString()
    },
    setTotalTax () {
      var array = this.sales.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        console.log('tax detail: ' + array[i].tax)
        // sum += parseFloat(array[i].discount) * parseFloat(array[i].qty)
        if (isNaN(array[i].tax)) {
          sum += parseFloat(array[i].tax) * parseFloat(array[i].qty)
        } else {
          sum += array[i].tax * parseInt(array[i].qty)
        }
      }
      return sum.toString()
    },
    setIdDetail: function (id) {
      this.idDetail = id
      this.$refs.refreshProduct.refresh()
      // var payload = {
      //   date: this.sales.sale_date
      // }
      // this.$store.dispatch('getProductWithTotal', payload)
      // this.getType()
    },
    setIdDetailRetur: function (id) {
      this.detail = this.sales.details.find(d => d.id === id)
      console.log(this.detail)
    },
    async selectProduct (value) {
      this.$Progress.start()
      this.loader.isLoading = true
      var dtl = this.sales.details.find(d => d.product_no === value.product_no)
      if (dtl) {
        this.$swal('Error', 'Product already pick in detail', 'error')
        return false
      }
      var data = {
        product_no: value.product_no,
        date: this.sales.sale_date
      }
      await axios.post(productUrl + '/latest-price', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          var product = response.data.data
          var amount = parseFloat(product.price)
          var subtotal = amount
          var dpp = 0
          var tax = this.taxList.find(d => d.id === this.sales.tax_id)
          var taxAmount = 0
          if (tax.include === false) {
            taxAmount = subtotal * tax.amount / 100
            dpp = subtotal
          } else {
            if (tax.amount === '0') {
              taxAmount = 0
              dpp = subtotal
            } else {
              taxAmount = subtotal * (tax.amount / 100)
              dpp = subtotal - taxAmount
            }
          }
          var detail = this.sales.details[this.idDetail]
          detail.sale_no = this.sales.sale_no
          detail.branch_no = this.sales.branch_no
          detail.product_no = product.product_no
          detail.description = product.product_name
          detail.internal_code = product.barcode
          detail.qty = 1
          detail.serial_number = null
          detail.uom_id = product.uom_id
          detail.price = product.price.toString()
          detail.tax_id = this.sales.tax_id
          detail.tax = taxAmount
          detail.discount = '0'
          detail.discount_percentage = '0'
          detail.subtotal = dpp
          detail.total = (dpp + taxAmount) * detail.qty
          detail.state = 'create'
          detail.uomList = product.uomList
          detail.warehouse_no = this.sales.warehouse_no
          detail.cost = '0'
          detail.cost_id = product.cost_id
          this.setTax()
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
      var body = {
        product_no: value.product_no
      }
      await axios.post(productUrl + '/uom/list', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          var dt = this.sales.details[this.idDetail]
          dt.uomList = response.data.data
          dt.uom_id = value.uom_id
        })
    },
    async printPreview () {
      await this.$refs.printPreview.getInvoice()
    },
    async print (status) {
      if (status === 'bstk') {
        if (parseFloat(this.customerOutstandingDueTotal) > 0) {
          let ots = 0
          if (this.customerOutstandingDueTotal === null) {
            ots = '0'
          } else if (typeof this.customerOutstandingDueTotal === 'string') {
            ots = parseFloat(this.customerOutstandingDueTotal).toLocaleString('id-ID')
          } else {
            ots = parseFloat(this.customerOutstandingDueTotal).toLocaleString('id-ID')
          }
          if (this.sales.customer.rating_id === 'vip') {
          } else {
            await this.$swal('Error', 'Pengiriman tidak dapat diproses<br> masih ada piutang > ' + this.settingDueDatePlafond + ' <strong>' + ots + '</strong>', 'error')
            return false
          }
        }
      }
      if (this.sales.status !== 'approved') {
        this.$swal('Error', 'Penjualan harus di approve dulu', 'error')
        return false
      }
      if (this.sales.lock === false) {
        if (this.isPlafondOke === false) {
          this.$swal('Error', 'Penjualan tidak dapat diproses<br>Plafond piutang tidak mencukupi <strong>' + this.customerOutstandingTotal + '</strong>', 'error')
          return false
        }
      } else {
        this.$Progress.start()
        this.loader.isLoading = true
        var data = {
          id: this.sales.id,
          format: null,
          data: this.groupDetail,
          status: null
        }
        if (data.length === 0) {
          this.$swal('Error', 'Data masih kosong', 'error')
          return false
        }
        var url = null
        if (status === 'invoice') {
          url = sale2Url + '/invoice2'
          if (this.sales.lock === true) {
          } else {
            await this.updateSales('no reply')
          }
        } else {
          url = sale2Url + '/bstk2'
          if (this.sales.lock === false) {
            await this.approveAll()
          }
        }
        await axios.post(url, data, { responseType: 'blob' })
          .then(response => {
            const objectUrl = URL.createObjectURL(response.data)
            console.log('Showing PDF...')
            window.open(objectUrl, '_blank')
            this.$Progress.finish()
            this.loader.isLoading = false
          })
          .catch(error => {
            this.$Progress.finish()
            this.loader.isLoading = false
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    getInput: function () {
      this.sales.payments[0].price = this.getTotal.replace(/\./g, '')
    },
    async onBarcodeScanned (barcode) {
      console.log('has listener ' + this.$barcodeScanner.hasListener())
      var obj = {
        barcode: barcode
      }
      console.log(barcode)
      await axios.post(productUrl + '/scan/barcode', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          const product = response.data.data
          var productDetail = this.sales.details.find(d => d.product_no === product.product_no)
          if (productDetail) {
            productDetail.qty = parseInt(productDetail.qty) + 1
            productDetail.total = parseInt(productDetail.qty) * parseFloat(productDetail.price.replace(/\./g, ''))
          } else {
            // const price = product.productGet.uomList.find(d => d.category_id === 3)
            var obj = {
              id: Math.floor(Math.random() * (99999999 - 66666666) + 66666666),
              product_no: product.product_no,
              product: product.productGet.product_name,
              description: product.productGet.product_description,
              qty: 1,
              uom_id: product.productGet.uom_id,
              price: product.price,
              tax_id: null,
              tax: '0',
              discount: '0',
              total: product.price,
              edit: false,
              uomList: product.productGet.uomList
            }
            this.sales.details.push(obj)
          }
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    getCustomerList: function () {
      this.$store.dispatch('getCustomerList')
    },
    createCustomer: function (customer) {
      this.sales.customer_no = customer.customer_no
      this.sales.customer = customer
    },
    salesPayment: function () {
      this.$emit('onPayment', this.sales)
    },
    createBastk: function () {
      // this.$emit('onBstk', this.sales)
      const id = this.sales.id
      this.$router.push({ name: 'sales-bstk', params: { id } })
    },
    setTax: function () {
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        this.calcRow(i)
      }
    },
    detailClear: function () {
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        // array[i].edit = false
      }
    },
    backParent: function () {
      this.alert = []
      this.alertCustomer = null
      this.customerOutstanding = 0
      this.$store.commit('SET_CUSTOMER_OUTSTANDING_TOTAL', 0)
      this.$store.commit('SET_CUSTOMER_OUTSTANDING_DUE_TOTAL', 0)
      this.$store.commit('SET_CUSTOMER_PLAFOND_AMOUNT', 0)
      this.$emit('backClicked')
    },
    async syncOrderAll (reply) {
      if (reply === 'reply') {
        await this.$Progress.start()
        this.loader.isLoading = true
      }
      var array = this.sales.orders
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].details
        for (let a = 0; a < arr.length; a++) {
          var obj = {
            product_no: arr[a].product_no,
            order_no: arr[a].order_no,
            price: arr[a].price,
            uom_id: arr[a].uom_id
          }
          await axios.post(saleOrderUrl + '/sync-to-sales', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
            })
            .catch(error => {
              console.log(error)
              console.log(error.response.data.message)
              this.alert.push(error.response.data.message)
            })
        }
      }
      if (reply === 'reply') {
        await this.$Progress.finish()
        this.loader.isLoading = false
      }
    },
    async syncOrder2 (reply) {
      await this.$Progress.start()
      this.loader.isLoading = true
      var array = this.salesDetail
      for (let i = 0; i < array.length; i++) {
        var obj = {
          product_no: array[i].product_no,
          order_no: array[i].order_no,
          price: array[i].price.replace(/\./g, ''),
          uom_id: array[i].uom_id
        }
        var resp = {
          error: false,
          message: null
        }
        console.log(obj)
        await axios.post(saleOrderUrl + '/sync-to-sales', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$Progress.fail()
            this.loader.isLoading = false
            if (reply === 'reply') {
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            }
            resp.error = true
            resp.message = error.response.data.message
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      if (reply === 'reply') {
        if (resp.error === true) {
          await this.$swal('Error', resp.message, 'error')
        } else {
          await this.$swal('Success', resp.message, 'success')
        }
      }
    },
    async syncOrder () {
      var dataSync = {
        date: this.sales.sale_date,
        customer_no: this.sales.customer_no
      }
      await axios.post(salesUrl + '/order/sync-product', dataSync, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backParentID', this.sales.id)
        })
        .catch(error => {
          console.log(error)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
          return false
        })
    },
    async updateSales (reply) {
      await this.validateCustomer()
      if (this.validateCustomerStatus) {
        return false
      }
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.validateDetailProduct()
      if (this.alert.length > 0) {
        window.scrollTo(0, 0)
        this.$swal('Error', 'Data tidak valid, cek terlebih dahulu', 'error')
        await this.$Progress.finish()
        this.loader.isLoading = false
        return false
      }
      await this.refreshCalc()
      var warehouse = this.warehouseList.find(d => d.company_no === this.sales.company_no)
      var dataDeliver = []
      dataDeliver.push(this.deliveryData)
      this.data = {
        sale_no: null,
        sale_date: this.sales.sale_date,
        sale_due_date: this.sales.sale_due_date,
        type_id: this.sales.type_id,
        customer_no: this.sales.customer_no,
        branch_no: this.sales.branch_no,
        warehouse_no: warehouse ? warehouse.warehouse_no : null,
        subtotal: this.getSubtotal,
        tax_id: this.sales.tax_id,
        tax: this.sales.tax,
        discount: this.sales.discount,
        total: this.sales.total,
        delivery_cost: this.sales.delivery_cost.replace(/\./g, ''),
        deliver_no: null,
        salesman_id: this.sales.salesman_id,
        salesman: null,
        supervisor_id: this.sales.supervisor_id,
        status: this.sales.status,
        notes: this.sales.notes,
        check_tanda_terima: this.sales.check_tanda_terima,
        price_id: this.sales.price_id,
        company_no: this.sales.company_no,
        term_due_id: this.sales.term_due_id,
        orders: this.sales.orders,
        deliveries: dataDeliver
      }
      var dataSales = {}
      console.log('data sales')
      console.log(this.data)
      await axios.put(salesUrl + '/' + this.sales.id, this.data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          dataSales = response.data.data
          console.log('data sales')
          console.log(dataSales)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
      var array = this.salesDetail
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_no !== null || array[i].product_no !== '') {
          var obj = {}
          if (typeof array[i].id === 'undefined') {
            obj = {
              sale_no: dataSales.sale_no,
              sale_date: dataSales.sale_date,
              branch_no: dataSales.branch_no,
              product_no: array[i].product_no,
              product_sku: array[i].product_sku,
              description: array[i].description,
              qty: array[i].qty,
              serial_number: array[i].serial_number,
              uom_id: array[i].uom_id,
              price: array[i].price.replace(/\./g, ''),
              tax_id: array[i].tax_id,
              tax: array[i].tax,
              discount: array[i].discount,
              discount_percentage: array[i].discount_percentage == null ? 0 : array[i].discount_percentage,
              subtotal: array[i].subtotal,
              total: array[i].total,
              queue: array[i].queue,
              warehouse_no: array[i].warehouse_no === null ? warehouse.warehouse_no : array[i].warehouse_no,
              internal_code: array[i].internal_code,
              cost: null,
              cost_id: null,
              sec_serial_number: array[i].sec_serial_number,
              company_no: this.sales.company_no,
              order_no: array[i].order_no
            }
          } else {
            obj = {
              id: array[i].id,
              sale_no: dataSales.sale_no,
              sale_date: dataSales.sale_date,
              branch_no: dataSales.branch_no,
              product_no: array[i].product_no,
              product_sku: array[i].product_sku,
              description: array[i].description,
              qty: array[i].qty,
              serial_number: array[i].serial_number,
              uom_id: array[i].uom_id,
              price: array[i].price.replace(/\./g, ''),
              tax_id: array[i].tax_id,
              tax: array[i].tax,
              discount: array[i].discount,
              discount_percentage: array[i].discount_percentage == null ? 0 : array[i].discount_percentage,
              subtotal: array[i].subtotal,
              total: array[i].total,
              queue: array[i].queue,
              warehouse_no: array[i].warehouse_no === null ? warehouse.warehouse_no : array[i].warehouse_no,
              internal_code: array[i].internal_code,
              cost: null,
              cost_id: null,
              sec_serial_number: array[i].sec_serial_number,
              company_no: this.sales.company_no,
              order_no: array[i].order_no
            }
          }
          console.log(obj)
          await axios.post(salesUrl + '/detail', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
            })
            .catch(error => {
              console.log(error.response)
            })
          var bodyDelivery = {
            sale_no: dataSales.sale_no,
            serial_number: null,
            sec_serial_number: null,
            product_no: array[i].product_no
          }
          console.log('bodyDelivery')
          console.log(bodyDelivery)
          await axios.post(salesUrl + '/delivery/detail', bodyDelivery, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
            })
            .catch(error => {
              console.log(error.response)
            })
        }
      }
      var wo = this.sales.workshops
      console.log('Workshop data')
      console.log(wo)
      for (let a = 0; a < wo.length; a++) {
        var wos = {
          id: wo[a].id,
          sale_no: dataSales.sale_no
        }
        console.log('workshops')
        console.log(wos)
        await axios.post(workshopUrl + '/sales-process', wos, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
          })
      }
      await this.$swal('Sales', 'Process HPP & Kartu Stock?', 'success')
      await this.syncOrderAll('no reply')
      // await this.setCOGSAll('no reply')
      await this.$Progress.finish()
      this.loader.isLoading = false
      this.alert = []
      if (reply === 'reply') {
        await this.$swal('Success', 'Success update sales and order', 'success')
        // await this.$emit('backClicked')
        this.backParent()
      }
    },
    async validateDetailProduct () {
      this.alert = []
      // details array
      var arrOrder = this.sales.orders
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        const stockSale = parseFloat(array[i].qty)
        var gpm = this.groupDetailColl.find(d => d.product_no === array[i].product_no)
        var qtyExist = gpm ? gpm.qty : '0'
        if (stockSale > 0) {
          var obj = {
            product_no: array[i].product_no,
            date: this.sales.sale_date
          }
          var url = productUrl + '/cost/get-saldo'
          await axios.post(url, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              const stockQty = parseFloat(response.data.data.qty)
              var qtySaldo = stockQty + parseFloat(qtyExist)
              console.log('Remaining ' + array[i].product_no + ' ' + stockQty + '+ ' + qtyExist + ' = ' + qtySaldo)
              var qtyRemaining = qtySaldo - stockSale
              // Floating-point tolerance to avoid false negative from residue like 5.999999999999986
              var tolerance = 0.0001
              if (qtyRemaining < -tolerance) {
                this.alert.push('Stock <strong>[' + array[i].product_no + ']</strong> ' + array[i].description + ' saldo stock kurang = (' + qtySaldo + ')')
              }
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        } else {
          this.alert.push('Stock <strong>[' + array[i].product_no + ']</strong> ' + array[i].description + ' qty stock tidak boleh kosong')
        }
        if (array[i].uom_id === null) {
          this.alert.push('Stock <strong>[' + array[i].product_no + ']</strong> ' + array[i].description + ' uom tidak boleh kosong')
        }
        var checkOrder = 0
        for (let b = 0; b < arrOrder.length; b++) {
          console.log('order in sales' + array[i].order_no)
          console.log('orderNo loop: ' + arrOrder[b].order_no)
          if (array[i].order_no === arrOrder[b].order_no) {
            checkOrder = 1
          }
        }
        console.log(array[i].product_no + ' checkOrder: ' + checkOrder)
        // if (checkOrder === 0) {
        //   this.alert.push('<strong>Product: [' + array[i].product_no + '] ' + array[i].description + ' </strong> tidak ada di <strong>ORDER</strong>')
        // }
      }
      // per sales
      if (this.sales.customer_no === null) {
        this.alert.push('<b>Customer</b> harus diinput terlebih dahulu')
      }
      if (this.sales.salesman_id === null) {
        this.alert.push('<b>Salesman</b> harus diinput terlebih dahulu')
      }
      if (this.sales.tax_id === null) {
        this.alert.push('<b>Tax</b> harus diinput terlebih dahulu')
      }
      if (this.sales.company_no === null) {
        this.alert.push('<b>Company</b> harus diinput terlebih dahulu')
      }
      if (this.sales.type_id === null || this.sales.type_id === '') {
        this.alert.push('<b>Type</b> harus diinput terlebih dahulu')
      }
      var total = parseFloat(this.sales.total)
      if (total === 0) {
        this.alert.push('<b>Total</b> masih kosong, cek kembali inputan product')
      }
      var arr = this.sales.details
      var result = []
      var resultProductNo = []
      var resultProductUom = []
      arr.reduce(function (res, value) {
        // Check product_no null & duplicate
        if (value.product_no !== null) {
          var price = value.price.replace(/\./g, '')
          var key = value.product_no + price + value.order_no
          console.log(key)
          if (!res[key]) {
            res[key] = {
              id: key,
              product_no: value.product_no,
              price: parseFloat(price).toLocaleString('id-ID')
            }
          } else {
            result.push({
              id: key,
              product_no: value.product_no,
              price: parseFloat(price).toLocaleString('id-ID')
            })
          }
          // check uom null
          if (value.uom_id === null) {
            resultProductUom.push({
              id: value.id + 'uom',
              product_no: value.product_no
            })
          }
          if (value.product_no === null) {
            resultProductNo.push({
              id: res
            })
          }
        } else {
          resultProductNo.push({
            id: res
          })
        }
        return res
      }, {})
      if (result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          this.alert.push('Duplicate Product & Price (<b>' + result[i].product_no + ' | ' + result[i].price + '</b>)')
        }
      }
      if (resultProductUom.length > 0) {
        for (let z = 0; z < resultProductUom.length; z++) {
          this.alert.push('<b>Uom</b> cannot be null ' + resultProductUom[z].product_no)
        }
      }
      if (resultProductNo.length > 0) {
        var msg = {}
        for (let h = 0; h < resultProductNo.length; h++) {
          msg = '<b>Product</b> harus diinput terlebih dahulu (tidak boleh kosong)'
        }
        this.alert.push(msg)
      }
    },
    validateDetail () {
      var array = this.sales.details
      var loop = []
      var resp = {
        error: false,
        message: null,
        data: []
      }
      for (let i = 0; i < array.length; i++) {
        if (array[i].uom_id === null) {
          var ob = {
            product_no: array[i].product_no
          }
          resp = {
            error: true,
            message: 'Uom harus diisi'
          }
          resp.data.push(ob)
        } else if (array[i].qty === null || array[i].qty === 0 || array[i].qty === '0') {
          var ob2 = {
            product_no: array[i].product_no
          }
          console.log(ob2)
          loop.push(ob2)
          resp = {
            error: true,
            message: 'Qty tidak boleh 0',
            data: loop
          }
        }
      }
      console.log('response validate')
      console.log(resp)
      if (resp.error === true) {
        var msg = resp.message
        var productMsg = ''
        for (let c = 0; c < resp.data.length; c++) {
          if (c === 0) {
            productMsg = resp.data[c].product_no
          } else {
            productMsg = productMsg + ' ,' + resp.data[c].product_no
          }
        }
        this.$swal('Error', msg + '[' + productMsg + ']', 'error')
        return false
      } else {
        return true
      }
    },
    async validateCustomer () {
      let check = false
      if (this.sales.customer.rating_id === 'vip') {
      } else {
        // restrict by rating
        if (this.sales.customer.rating_id === 'middle-high' || this.sales.customer.rating_id === 'bad' || this.sales.customer.rating_id === 'black-list') {
          check = true
          await this.$swal('Error', 'Customer Rating (' + this.sales.customer.rating + ') not valid.', 'error')
        }
        if (this.isEnablePlafondDueDate) {
          let ots = 0
          if (this.customerOutstandingDueTotal === null) {
            ots = '0'
          } else if (typeof this.customerOutstandingDueTotal === 'string') {
            ots = parseFloat(this.customerOutstandingDueTotal).toLocaleString('id-ID')
          } else {
            ots = parseFloat(this.customerOutstandingDueTotal).toLocaleString('id-ID')
          }
          const settingPlafond = this.settingList.find(d => d.name === 'customer_sales_plafond_due_date_enable' && d.company_no === this.sales.company_no)
          const maxAge = settingPlafond ? settingPlafond.value : 0
          if (parseFloat(this.customerOutstandingDueTotal) > 0) {
            await this.$swal('Error', 'Penjualan tidak dapat diproses<br> masih ada piutang > ' + maxAge + ' <strong>' + ots + '</strong>', 'error')
            check = true
          }
        }
        if (this.isEnablePlafond) {
          if (this.customerPlafondAmount !== 0) {
            if (parseFloat(this.customerOutstandingTotal) >= parseFloat(this.customerPlafondAmount)) {
              let plafondAmount = 0
              let outstanding = 0
              // plafon
              if (this.customerPlafondAmount === null) {
                plafondAmount = '0'
              } else if (typeof this.customerPlafondAmount === 'string') {
                plafondAmount = parseFloat(this.customerPlafondAmount).toLocaleString('id-ID')
              } else {
                plafondAmount = parseFloat(this.customerPlafondAmount).toLocaleString('id-ID')
              }
              // outstanding
              if (this.customerOutstandingTotal === null) {
                outstanding = '0'
              } else if (typeof this.customerOutstandingTotal === 'string') {
                outstanding = parseFloat(this.customerOutstandingTotal).toLocaleString('id-ID')
              } else {
                outstanding = parseFloat(this.customerOutstandingTotal).toLocaleString('id-ID')
              }
              await this.$swal('Error', 'Penjualan tidak dapat diproses<br>Plafon piutang (' + plafondAmount + ') tidak mencukupi. Piutang: <strong>' + outstanding + '</strong>', 'error')
              check = true
            }
          }
        }
        if (this.sales.customer.rating_id === 'evaluate' && parseFloat(this.customerOutstandingTotalSalePaid) === 0 && parseFloat(this.customerOutstandingTotalSales > 1)) {
          await this.$swal('Error', 'Penjualan tidak dapat diproses, customer masih dalam evaluasi dan ada piutang', 'error')
          check = true
        }
        const sType = this.salesTypeList.find(d => d.id === this.sales.type_id)
        if (sType) {
          if (sType.name === 'Titipan') {
            if (parseFloat(this.sales.total) < 1000000) {
              await this.$swal('Error', 'Titipan tidak boleh kurang dari 1juta', 'error')
              check = true
            }
          }
        }
      }
      this.validateCustomerStatus = check
    },
    async createSales () {
      await this.validateCustomer()
      if (this.validateCustomerStatus) {
        return false
      }
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.validateDetailProduct()
      if (this.alert.length > 0) {
        window.scrollTo(0, 0)
        this.$swal('Error', 'Data tidak valid, cek terlebih dahulu', 'error')
        await this.$Progress.finish()
        this.loader.isLoading = false
        return false
      }
      await this.refreshCalc()
      var warehouse = this.warehouseList.find(d => d.company_no === this.sales.company_no)
      var dataDeliver = []
      dataDeliver.push(this.deliveryData)
      const salesDate = new Date(this.sales.sale_date)
      const nowDate = new Date()
      const newSalesDate = salesDate.getFullYear() + '-' + (salesDate.getMonth() + 1) + '-' + salesDate.getDate() + ' ' + nowDate.getHours() + ':' + nowDate.getMinutes() + ':' + nowDate.getSeconds()
      this.data = {
        sale_no: null,
        sale_date: newSalesDate,
        sale_due_date: this.sales.sale_due_date,
        type_id: this.sales.type_id,
        customer_no: this.sales.customer_no,
        branch_no: this.sales.branch_no,
        warehouse_no: warehouse ? warehouse.warehouse_no : null,
        subtotal: this.getSubtotal,
        tax_id: this.sales.tax_id,
        tax: this.sales.tax,
        discount: this.sales.discount,
        total: this.sales.total,
        delivery_cost: this.sales.delivery_cost.replace(/\./g, ''),
        deliver_no: null,
        salesman_id: this.sales.salesman_id,
        salesman: null,
        supervisor_id: this.sales.supervisor_id,
        price_id: this.sales.price_id,
        company_no: this.sales.company_no,
        term_due_id: this.sales.term_due_id,
        orders: this.sales.orders,
        deliveries: dataDeliver,
        lock: false,
        status: 'Open',
        notes: this.sales.notes,
        check_tanda_terima: this.sales.check_tanda_terima
      }
      console.log(this.data)
      var dataSales = {}
      await axios.post(salesUrl, this.data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          dataSales = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          return false
        })
      var array = this.sales.details
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_no !== null || array[i].product_no !== '') {
          var obj = {
            sale_no: dataSales.sale_no,
            sale_date: dataSales.sale_date,
            branch_no: dataSales.branch_no,
            product_no: array[i].product_no,
            product_sku: array[i].product_sku,
            description: array[i].description,
            qty: array[i].qty,
            serial_number: array[i].serial_number,
            uom_id: array[i].uom_id,
            price: array[i].price.replace(/\./g, ''),
            tax_id: array[i].tax_id,
            tax: array[i].tax,
            discount: array[i].discount,
            discount_percentage: array[i].discount_percentage == null ? 0 : array[i].discount_percentage,
            subtotal: array[i].subtotal,
            total: array[i].total,
            queue: array[i].queue,
            warehouse_no: array[i].warehouse_no === null ? warehouse.warehouse_no : array[i].warehouse_no,
            internal_code: array[i].internal_code,
            cost: null,
            cost_id: null,
            sec_serial_number: array[i].sec_serial_number,
            company_no: this.sales.company_no,
            order_no: array[i].order_no
          }
          await axios.post(salesUrl + '/detail', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
            })
            .catch(error => {
              console.log(error.response)
            })
          var bodyDelivery = {
            sale_no: dataSales.sale_no,
            serial_number: null,
            sec_serial_number: null,
            product_no: array[i].product_no
          }
          await axios.post(salesUrl + '/delivery/detail', bodyDelivery, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
            })
            .catch(error => {
              console.log(error.response)
            })
          this.setQtyTotal(array[i].product_no)
        }
      }
      var wo = this.sales.workshops
      for (let a = 0; a < wo.length; a++) {
        var wos = {
          id: wo[a].id,
          sale_no: dataSales.sale_no
        }
        console.log(wos)
        await axios.post(workshopUrl + '/sales-process', wos, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      // await this.setCOGSAll()
      await this.syncOrderAll('no reply')
      console.log(alert)
      if (this.alert.length > 0) {
        await this.$emit('backParentID', dataSales.id)
        this.alert = []
      } else {
        await this.$swal('Success', 'Success create sales', 'success')
        await this.backParent()
        this.alert = []
      }
    },
    addNewLine: function () {
      // this.$store.dispatch('getProductList')
      // var newID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      this.sales.details.push({
        sale_no: null,
        sale_date: null,
        branch_no: this.sales.branch_no,
        company_no: this.sales.company_no,
        product_no: null,
        product_sku: null,
        description: null,
        qty: '0',
        serial_number: null,
        sec_serial_number: null,
        uom_id: null,
        price: '0',
        tax_id: null,
        tax: '0',
        total_tax: '0',
        discount: '0',
        discount_percentage: '0',
        subtotal: '0',
        total: '0',
        queue: '1',
        warehouse_no: this.sales.warehouse_no,
        state: 'create',
        edit: false,
        uomList: [{
          id: null,
          name: null,
          category_id: null,
          type_id: null,
          ratio: null,
          active: null
        }],
        cost: '0',
        cost_id: null,
        margin: '0',
        margin_percentage: '0',
        internal_code: null
      })
      this.state = 'create'
      // sales type
      // var styp = this.salesTypeList.find(d => d.id === this.sales.type_id)
      // var obj = {
      //   salesType: styp.name
      // }
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    editDetail: function (id) {
      // var p = this.sales.details.find(d => d.id === id)
      this.idDetail = id
      // sales type
      // var styp = this.salesTypeList.find(d => d.id === this.sales.type_id)
      // var obj = {
      //   salesType: styp.name
      // }
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    async removeDetail (index) {
      var detail = this.sales.details[index]
      var orderNo = detail.order_no
      this.calcRow(0)
      if (typeof detail.id === 'undefined') {
        this.sales.details.splice(index, 1)
        this.calcRow(0)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(salesDetailUrl + '/' + detail.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                console.log(response.data.message)
                this.calcRow(0)
                var data = {
                  date: this.sales.sale_date,
                  product_no: detail.product_no,
                  type: 'all',
                  company_no: null
                }
                axios.post(productUrl + '/cost/sync', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
                  .then(response => {
                    console.log(response.data.message)
                  })
                  .catch(error => {
                    console.log(error)
                    console.log(error.response)
                  })
                this.sales.details.splice(index, 1)
                var orderDetail = this.sales.details.filter(d => d.order_no === orderNo)
                if (orderDetail.length === 0) {
                  const orderID = this.sales.orders.findIndex(d => d.order_no === orderNo)
                  this.sales.orders.splice(orderID, 1)
                }
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    deleteRetur (id) {
      var retur = this.sales.returs.find(d => d.id === id)
      var qty = retur.qty
      var detail = this.sales.details.find(d => d.product_no === retur.product_no)
      var index = this.sales.returs.findIndex(d => d.id === id)
      if (retur.state === 'create') {
        detail.qty = parseInt(detail.qty) + parseInt(qty)
        this.sales.returs.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(salesReturUrl + '/' + retur.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                detail.qty = parseInt(detail.qty) + parseInt(qty)
                this.sales.returs.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    async selectCustomerList (customer) {
      console.log(customer)
      await this.$Progress.start()
      this.loader.isLoading = true
      this.sales.customer_no = customer.customer_no
      this.sales.customer = customer
      // this.sales.customer = customer
      this.sales.term_due_id = customer.term_due_id
      var data = {
        customer_no: customer.customer_no,
        date: this.sales.sale_date
      }
      await axios.post(customerUrl + '/sales-outstanding-expire', data, { headers: getHeader() })
        .then(response => {
          console.log(response.data)
          this.$store.commit('SET_CUSTOMER_OUTSTANDING_TOTAL', response.data.total_outstanding)
          this.$store.commit('SET_CUSTOMER_OUTSTANDING_TOTAL_SALES', response.data.total_sales)
          this.$store.commit('SET_CUSTOMER_OUTSTANDING_TOTAL_SALES_PAID', response.data.total_sales_paid)
          this.$store.commit('SET_CUSTOMER_OUTSTANDING_DUE_TOTAL', response.data.total_outstanding_due)
          this.$store.commit('SET_CUSTOMER_PLAFOND_AMOUNT', response.data.plafond_amount)
          this.$store.commit('SET_CUSTOMER_OUTSTANDING_SALES_LIST', response.data.data)
          this.sales.customer.rating_id = response.data.rating_id
          this.sales.customer.rating = response.data.rating
        })
        .catch(error => {
          console.log(error)
        })
      await axios.post(salesUrl + '/get-latest-sales', data, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          var sales = response.data.data
          if (this.sales.term_due_id === null) {
            this.sales.term_due_id = sales.term_due_id
          }
          this.sales.salesman_id = sales.salesman_id
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
        })
      if (this.sales.salesman_id !== null) {
        const body = {
          employee_no: this.sales.salesman_id
        }
        console.log('employeeUrl + /get-by-no')
        await axios.post(employeeUrl + '/get-by-no', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            this.sales.supervisor_id = response.data.data.supervisor_id
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$Progress.fail()
            this.loader.isLoading = false
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
  .text-style {
    color: #28A745;
  }
</style>
